// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-23T19:57:11.862Z
// Property: Bishop's Court Apartments (ID: 6767906449166883)
// Collections: 26 amenities, 5 floorplans (live), 34 photos, 41 POIs, 1 reviews, 5 virtual tours, 7 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162446",
  "multihub_property_id": "6767906449166883",
  "property_external_id": "495882",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/bishops-court-apartments-rancho-cordova-ca/j07wjv6/",
  "property_google_business_url": "https://www.google.com/maps/place/Bishop's+Court+Apartments/data=!4m2!3m1!1s0x0:0xe4c8e6034eb0e7b5?sa=X&ved=2ahUKEwiVm92ChLySAxWzI0QIHat9IF0Q_BJ6BAgREAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "495882 p0505550",
  "property_status": null,
  "property_slug": "bishop's-court-apartments",
  "property_name": "Bishop's Court Apartments",
  "property_website_url": "https://www.ranchocordovacaliforniaapartments.com/",
  "property_domain": "https://www.ranchocordovacaliforniaapartments.com/",
  "property_address": "3300 Capital Center Drive",
  "property_full_address": "3300 Capital Center Dr, Rancho Cordova, CA 95670",
  "property_address_1": "3300 Capital Center Drive",
  "property_address_2": null,
  "property_address_city": "Rancho Cordova",
  "property_address_state": "CA",
  "property_address_zip_full": null,
  "property_address_zip": "95670",
  "property_address_country": "US",
  "property_address_county": "Sacramento County",
  "property_neighborhood_address": "Outer Rancho Cordova",
  "property_address_latitude": "38.5828265",
  "property_address_longitude": "-121.2932365",
  "property_email": "bishopscourt@ctlmanagement.com",
  "property_phone": "(279) 233-7400",
  "property_call_tracking_phone": null,
  "property_company_name": "CTL Management ",
  "property_company_url": "https://ctlmanagement.randallgroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Bishop's Court in Rancho Cordova, CA, where comfort meets convenience. Choose from spacious one, two, or three-bedroom apartments designed for modern living. Enjoy exceptional amenities like 24-hour fitness, two sparkling pools, and a vibrant resident activity program. Your perfect home awaits—explore our availability and schedule a tour today!",
  "property_long_description": "Welcome to Bishop's Court, your ideal apartment community located in the heart of Rancho Cordova, CA. Offering a variety of modern floor plans including one, two, and three-bedroom apartments, we cater to diverse lifestyles and preferences. Experience living in beautifully designed homes featuring spacious kitchens, enclosed patios, and full-size washers and dryers for ultimate convenience. \n\nOur community is equipped with exceptional amenities to enhance your living experience. Stay active in our 24-hour fitness center, take a refreshing dip in one of our two swimming pools, or unwind in one of our inviting spas. For your everyday needs, we provide 24-hour package lockers, online rent payments, and service requests – making apartment living seamless. \n\nAt Bishop's Court, community is at the forefront with our engaging resident activity program and a welcoming coffee bar perfect for catching up with neighbors. Families will appreciate our playground and game library, while professionals can take advantage of our business center and concierge services. Plus, enjoy stress-free living in our smoke-free apartments with flexible lease terms and abundant storage options. \n\nLocated in a vibrant neighborhood, we ensure convenience and comfort in every aspect of your life. Don't miss the opportunity to make Bishop's Court your new home! Find your perfect space today by browsing our availability or scheduling a tour to visit our community. Se Habla Español!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d2b18-c868-725e-8f7d-9f465f878086.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with blue lounge chairs and umbrellas.",
    "public_id": "019d2b18-c868-725e-8f7d-9f465f878086",
    "storage_key": "property/6767906449166883/019d2b18-c868-725e-8f7d-9f465f878086.webp",
    "width": 2560,
    "height": 1195
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "568",
  "property_year_built": "1989",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.83098591549296",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $500-600",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "25",
  "property_pet_restrictions": " ",
  "property_pet_policy_description": "Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old. Monthly pet rent is per pet.  Small caged animals are allowed without pet rent. Small caged animals that are allowed are common domesticated household birds, hamsters, gerbils, rabbits, guinea pigs, chinchillas and aquarium/terrarium animals including fish, hermit crabs, turtles, frogs, and small lizards.  Animals such as birds of prey, iguanas, ferrets, snakes, rats, mice, insects, arachnids (including spiders and scorpions), livestock, or any other exotic animals are not allowed. No animals are allowed that are venomous, biting, stinging, constricting, or pose a threat of infestation. Small animals are limited to a maximum of two, with the exception of fish which should be kept to a reasonable amount, and must be kept confined in appropriate and reasonably sized cages or aquariums/terrariums.  Resident shall not have more than three aquariums and the total combined capacity between all aquariums shall not exceed 40 gallons.",
  "property_petpolicy_info": " Maximum Number of Pets: 2 (Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old)\nMaximum Weight Limit: 25 pounds\nMonthly Pet Rent: $30 per pet",
  "property_online_leasing_url": "https://ranchocordovacaliforniaapartments.securecafe.com/onlineleasing/bishops-court/guestlogin",
  "property_resident_portal_url": "https://ranchocordovacaliforniaapartments.securecafenet.com/residentservices/bishops-court/userlogin",
  "property_apply_now_url": "https://ranchocordovacaliforniaapartments.securecafe.com/onlineleasing/bishops-court/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d7392-2c07-7598-928a-16fde0fc9a41.webp",
  "property_primary_logo_media": {
    "alt_text": "Bishop's Court Apartments logo",
    "public_id": "019d7392-2c07-7598-928a-16fde0fc9a41",
    "storage_key": "property/6767906449166883/019d7392-2c07-7598-928a-16fde0fc9a41.webp",
    "width": 686,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d7391-f97f-75de-b4a2-fc2a16a96ce7.webp",
  "property_secondary_logo_media": {
    "alt_text": "Bishop's Court Apartments logo",
    "public_id": "019d7391-f97f-75de-b4a2-fc2a16a96ce7",
    "storage_key": "property/6767906449166883/019d7391-f97f-75de-b4a2-fc2a16a96ce7.webp",
    "width": 685,
    "height": 160
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019de0b2-ccd9-72be-b8f6-5bd59eae0020.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Generic placeholder image",
    "public_id": "019de0b2-ccd9-72be-b8f6-5bd59eae0020",
    "storage_key": "property/6767906449166883/019de0b2-ccd9-72be-b8f6-5bd59eae0020.webp",
    "width": 686,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019de0b2-c04d-769e-87af-066b977a75d4.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Property management company logo",
    "public_id": "019de0b2-c04d-769e-87af-066b977a75d4",
    "storage_key": "property/6767906449166883/019de0b2-c04d-769e-87af-066b977a75d4.webp",
    "width": 686,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
  "property_company_logo_media": {
    "alt_text": "CTL Management logo",
    "public_id": "019d9c74-7219-719e-b7ea-ff6185375ae5",
    "storage_key": "company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
    "width": 201,
    "height": 60
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#14473D",
  "property_secondary_color": "#9EBAC2",
  "property_font_color": "#14473D",
  "property_color_4": "#F27859",
  "property_color_3": "#4F756E",
  "property_color_5": "#FAAD45",
  "property_color_6": "#FCF5F0",
  "property_color_7": "#CFDBE0",
  "property_color_8": "#FCE3BD",
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "625 - 970",
  "property_sqft_min": "625",
  "property_sqft_max": "970",
  "property_price_range": "1660 - 2685",
  "property_price_min": "1660",
  "property_price_max": "2685",
  "property_available_units": 16,
  "property_facebook_url": "https://www.facebook.com/bishopscourtapartments",
  "property_instagram_url": "https://www.instagram.com/reel/DXVoTT_gYZP/#:~:text=Bishop's%20Court%20Estate.-,It's%20something%20you%20will%20FEEL%20during%20your%20visit%2C%20whether%20an,or%20even%20during%20our%20events.",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJDcFuEzzdmoARteewTgPmyOQ",
  "property_youtube_url": "https://www.youtube.com/watch?v=cZTvR-WXt4c",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Property+Management&find_loc=Rancho+Cordova%2C+CA",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Bishop's Court",
  "property_home_romance_title": "Embrace the Joy of Living in Your Dream Home",
  "property_home_amenities_blurb": "Welcome to Bishop's Court in Rancho Cordova, CA, where modern living meets comfort. Choose from one, two, or three-bedroom apartments designed for your lifestyle. Enjoy our 24-hour fitness center, relaxing spas, and inviting coffee bar while basking in the convenience of online rent payments and package lockers. Your ideal home awaits!",
  "property_home_floorplans_blurb": "At Bishop's Court in Rancho Cordova, CA, our thoughtfully designed one, two, and three-bedroom apartments offer the perfect blend of comfort and style. With a variety of unique layouts, you're sure to find the ideal space for your lifestyle. Browse our available homes today to start your next chapter!",
  "property_home_gallery_blurb": "At Bishop's Court in Rancho Cordova, CA, choose from one, two, or three-bedroom floor plans designed for comfort and style. Enjoy 24-hour fitness, refreshing pools, and a welcoming coffee bar. Experience an engaging resident lifestyle with activities and convenient amenities—all in a smoke-free haven. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to Bishop's Court in Rancho Cordova, CA, where your ideal living space awaits! Choose from spacious one, two, or three-bedroom floor plans. Immerse yourself in the vibrant neighborhood, featuring the serene Hagan Community Park, dynamic ARC Stadium, and the fun-filled Rebounderz indoor adventure park. Explore the local favorites today!",
  "property_home_reviews_blurb": "Welcome to Bishop's Court in Rancho Cordova, CA, where serenity meets community spirit. Our residents rave about the myriad of activities, from festive holiday gatherings to refreshing pool parties. With convenient in-unit laundry and a friendly staff, it's no wonder one resident described Bishop's Court as \"absolutely loveable.\" Join us!",
  "property_neighborhood_blurb": "At Bishop's Court in Rancho Cordova, the vibrant community extends beyond your doorstep. Enjoy close proximity to American River College, Rebounderz Indoor Trampoline Park, and serene parks like Effie Yeaw Nature Center. Dive into your new neighborhood, where convenience meets adventure. Uncover local favorites and enriching experiences waiting just around the corner!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Bishop's Court in Rancho Cordova, CA, elevate your lifestyle with our spacious one to three-bedroom apartments, boasting modern kitchens and luxurious oversized bathrooms. Enjoy endless amenities, from 24-hour fitness and refreshing pools to a vibrant resident activity program. Your ideal home awaits—experience the difference today!",
  "property_applynow_blurb": "At Bishop's Court in Rancho Cordova, CA, choose from spacious one, two, or three-bedroom floor plans designed for modern living. Enjoy exceptional amenities like 24-hour fitness centers, two refreshing pools, and a game library, all within a smoke-free community. Find your new home and lease online today!",
  "property_contactus_blurb": "At Bishop's Court in Rancho Cordova, CA, tailored living awaits with our diverse floor plans—one, two, and three bedrooms designed for comfort. Have questions or need assistance? Reach out to our dedicated leasing team today and let us help you find your perfect home. Your new lifestyle is just a call away!",
  "property_faqs_blurb": "At Bishop's Court in Rancho Cordova, CA, we offer a range of thoughtfully designed floor plans, including cozy one-bedroom retreats to spacious three-bedroom homes. Got questions? Our FAQs page provides essential insights to help you find your perfect fit within our vibrant community. ",
  "property_floorplans_blurb": "At Bishop's Court in Rancho Cordova, CA, our diverse floor plans cater to every lifestyle. Whether you're seeking a cozy one-bedroom retreat, a spacious two-bedroom haven, or a family-friendly three-bedroom sanctuary, we have the perfect space waiting for you. Browse our available apartment homes today and envision your ideal living experience!",
  "property_gallery_blurb": "At Bishop's Court in Rancho Cordova, CA, embrace a lifestyle of comfort and convenience. With spacious floor plans, luxurious amenities like two sparkling pools, a business center, and a vibrant resident activity program, your dream home awaits. Picture yourself living here—where every detail is designed for your enjoyment!",
  "property_interactivemap_blurb": "At Bishop's Court in Rancho Cordova, CA, choose from spacious one to three-bedroom floor plans, each featuring modern amenities like 24-hour fitness centers, two pools, and a coffee bar. Navigate your future home with our interactive community map, showcasing available apartments, pricing, and more—your ideal lifestyle awaits!",
  "property_pets_blurb": "At Bishop's Court in Rancho Cordova, CA, your furry friends will feel right at home! Enjoy pet-friendly living with space for two indoor cats or dogs, plus cozy accommodations for small caged animals. Relish the comfort of your stylish apartment while nurturing your pets in a vibrant community.",
  "property_referafriend_blurb": "At Bishop's Court in Rancho Cordova, CA, vibrant living meets community spirit. Choose from spacious one, two, or three-bedroom floor plans tailored for comfort. Great friends make great neighbors—refer a friend today and share the joy of calling Bishop's Court home together! Your ideal lifestyle awaits!",
  "property_residentaccess_blurb": "Welcome to Bishop's Court in beautiful Rancho Cordova, CA! Whether you prefer a cozy one-bedroom or a spacious three-bedroom, our floor plans cater to your needs. Access your resident portal to seamlessly pay rent, schedule maintenance, and enjoy all the conveniences of home at your fingertips!",
  "property_reviews_blurb": "At Bishop's Court in Rancho Cordova, residents cherish a vibrant community atmosphere. Enjoy fun gatherings like monthly breakfasts and holiday events, while the convenience of in-unit amenities—including full washers, dryers, and two refreshing pools—makes life exceptionally comfortable. Experience why so many love calling Bishop's Court home!",
  "property_created_at": "1762784659622",
  "property_scheduletour_blurb": "At Bishop's Court in Rancho Cordova, CA, our diverse floor plans cater to every lifestyle, from cozy one-bedroom retreats to spacious three-bedroom havens. Immerse yourself in a vibrant community that values comfort and connection. Curious about life here? Hear firsthand from our residents and imagine your new beginning!",
  "property_thankyou_blurb": "Thank you for reaching out! At Bishop's Court in Rancho Cordova, CA, we offer thoughtfully designed one, two, and three-bedroom floor plans tailored to your lifestyle. Our team will connect with you soon to help you find your perfect home in our vibrant community. Get ready for a new beginning!",
  "property_virtualtours_blurb": "Step into the elegance of Bishop's Court in Rancho Cordova, CA, where sophistication meets comfort. With inviting one to three-bedroom floor plans, each space is designed for your lifestyle. Experience it all—take a virtual tour today and find your perfect home in our vibrant community!",
  "property_copyright": "2026 All Rights Reserved. Bishop's Court",
  "property_seo_title_home": "Bishop's Court |  Apartments in Rancho Cordova, CA",
  "property_seo_description_home": "Discover luxury and comfort at Bishop's Court! Choose from spacious 1, 2, and 3-bedroom layouts with top-tier amenities. Find your home today!",
  "property_seo_title_floorplans": "Floor Plans | Rancho Cordova, CA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Bishop's Court in Rancho Cordova, CA! Choose from stylish one, two, or three-bedroom floor plans tailored for comfort.",
  "property_seo_title_amenities": "Amenities | Rancho Cordova, CA Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at Bishop's Court in Rancho Cordova! Enjoy two pools, a fitness center, and spacious homes with modern amenities. Join us today!",
  "property_seo_title_gallery": "Gallery | Apartments in Rancho Cordova, CA",
  "property_seo_description_gallery": "Experience refined living at Bishop's Court in Rancho Cordova. View stunning amenities and floor plans! Picture your perfect home in our vibrant community!",
  "property_seo_title_virtualtours": "Virtual Tours | Bishop's Court Apartments",
  "property_seo_description_virtualtours": "Experience Bishop's Court in Rancho Cordova, CA! Step inside our one, two, and three-bedroom apartments. Take a virtual tour today and envision your new home!",
  "property_seo_title_interactivemap": "Interactive Map | Bishop's Court Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Bishop's Court in Rancho Cordova! Explore unique floor plans and amenities using our interactive map.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Rancho Cordova, CA",
  "property_seo_description_neighborhood": "Explore vibrant Bishop's Court in Rancho Cordova, CA, with local hotspots and attractions that enhance your living experience!",
  "property_seo_title_contact": "Contact Us | Bishop's Court",
  "property_seo_description_contact": "Find your perfect home at Bishop's Court in Rancho Cordova, CA. With spacious one, two, and three-bedroom floor plans, our leasing team is here to help!",
  "property_seo_title_faqs": "FAQs | Apartments in Rancho Cordova, CA",
  "property_seo_description_faqs": "Find answers to your questions at Bishop's Court in Rancho Cordova! From spacious floor plans to top-notch amenities, your ideal home awaits.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Rancho Cordova, CA",
  "property_seo_description_reviews": "Experience life at Bishop's Court in Rancho Cordova, CA! Dive into resident reviews and see why our amenities and community vibes make us the perfect home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Rancho Cordova, CA",
  "property_seo_description_applynow": "Find your perfect haven at Bishop's Court in Rancho Cordova! Enjoy spacious layouts, amenities galore, and a welcoming community. Lease your new home today!",
  "property_seo_title_residentaccess": "Resident Access | Bishop's Court",
  "property_seo_description_residentaccess": "Manage your living experience at Bishop's Court, Rancho Cordova. Use the resident portal for rent, maintenance requests, and updates!",
  "property_seo_title_referafriend": "Refer A Friend | Bishop's Court",
  "property_seo_description_referafriend": "Help your friends find their perfect home at Bishop's Court in Rancho Cordova. Refer a friend today and bring great neighbors into our vibrant community!",
  "property_seo_title_scheduletour": "Schedule a Tour | Bishop's Court",
  "property_seo_description_scheduletour": "Experience the charm of Bishop's Court in Rancho Cordova, CA. Schedule your tour today and envision your future in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Bishop's Court",
  "property_seo_description_privacy": "At Bishop's Court in Rancho Cordova, your privacy matters. Read our privacy policy to learn how we protect your data while you enjoy community living.",
  "property_seo_title_accessibility": "Website Accessibility | Bishop's Court",
  "property_seo_description_accessibility": "Join Bishop's Court in Rancho Cordova, CA, where accessibility meets comfort. We prioritize inclusive living for everyone. Your new home awaits!",
  "property_seo_title_sitemap": "Sitemap | Bishop's Court",
  "property_seo_description_sitemap": "Find your way around Bishop's Court in Rancho Cordova, CA. Our sitemap provides easy access to everything you need for your perfect living experience!",
  "property_seo_title_thankyou": "Thank You | Bishop's Court",
  "property_seo_description_thankyou": "Thank you for reaching out to Bishop's Court in Rancho Cordova! Your journey to luxury living starts here—stay tuned for a prompt response from our team!",
  "property_seo_title_pets": "Pet Policy | Apartments in Rancho Cordova, CA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1778874517557",
  "amenities": [
    {
      "id": "ec_6d7a291f21d9a4826102d9b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "yardi",
      "external_id": "80428564",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d497e-bbd4-7751-a7a8-0a64f29570e4.webp",
      "amenity_image_media": {
        "alt_text": "Gym with cardio machines and weight training equipment.",
        "public_id": "019d497e-bbd4-7751-a7a8-0a64f29570e4",
        "storage_key": "property/6767906449166883/019d497e-bbd4-7751-a7a8-0a64f29570e4.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "fitness center and equipment side view at Bishop's Court Apartments, CA 95670,fitness center strength equipment at Bishop's Court Apartments, California, 95670,fitness center machines and fireplace at Bishop's Court Apartments, California",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_da11f74a07ead3887e19c741",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "yardi",
      "external_id": "80428568",
      "title": "2 Swimming Pools",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d42a1-824e-739f-bf1a-9dc568de6a6a.webp",
      "amenity_image_media": {
        "alt_text": "Swimming pool area with blue lounge chairs and umbrellas.",
        "public_id": "019d42a1-824e-739f-bf1a-9dc568de6a6a",
        "storage_key": "property/6767906449166883/019d42a1-824e-739f-bf1a-9dc568de6a6a.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "swimming pool deck at Bishop's Court Apartments, California,swimming pool side view at Bishop's Court Apartments, Rancho Cordova",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b9a1c4e3426c01c8710625ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "yardi",
      "external_id": "80428567",
      "title": "2 Spas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d497e-bcac-76ce-88a6-de2eae457845.webp",
      "amenity_image_media": {
        "alt_text": "Swimming pool and hot tub area with lounge chairs and umbrellas.",
        "public_id": "019d497e-bcac-76ce-88a6-de2eae457845",
        "storage_key": "property/6767906449166883/019d497e-bcac-76ce-88a6-de2eae457845.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "swimming pool and spa at Bishop's Court Apartments, California, 95670",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e7a97eea5527391d430b1f53",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "yardi",
      "external_id": "80428574",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d4a61-5c39-735e-b7d7-685e84a6e6d1.webp",
      "amenity_image_media": {
        "alt_text": "Playground equipment with slides and climbing structures in front of apartment buildings.",
        "public_id": "019d4a61-5c39-735e-b7d7-685e84a6e6d1",
        "storage_key": "property/6767906449166883/019d4a61-5c39-735e-b7d7-685e84a6e6d1.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "outdoor play structure at Bishop's Court Apartments, Rancho Cordova, California 95670,playground and picnic table at Bishop's Court Apartments, Rancho Cordova, 95670",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_73cc7fe71e7773c18d7037f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "yardi",
      "external_id": "80428572",
      "title": "Detached Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d4a61-8039-743e-9cb8-50d470ea371b.webp",
      "amenity_image_media": {
        "alt_text": "Row of garage doors with manicured landscaping.",
        "public_id": "019d4a61-8039-743e-9cb8-50d470ea371b",
        "storage_key": "property/6767906449166883/019d4a61-8039-743e-9cb8-50d470ea371b.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "garages and parking lot at Bishop's Court Apartments, Rancho Cordova, CA",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2e5d5131e65babf2038342f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "yardi",
      "external_id": "80428570",
      "title": "Concierge Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dc9fa30749b4acb7a7c4d9b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "yardi",
      "external_id": "80683696",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_004d236ff68da45a9dca21f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "yardi",
      "external_id": "86393070",
      "title": "Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_62dd648498a68fba83c96acd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "yardi",
      "external_id": "86393075",
      "title": "Game Library",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fa5e24f92857d13120ee79a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "yardi",
      "external_id": "87410411",
      "title": "24-Hour Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d594f-1e06-77bb-9d48-9ca744bba9ae.webp",
      "amenity_image_media": {
        "alt_text": "Amazon Hub package lockers with a touchscreen interface.",
        "public_id": "019d594f-1e06-77bb-9d48-9ca744bba9ae",
        "storage_key": "property/6767906449166883/019d594f-1e06-77bb-9d48-9ca744bba9ae.webp",
        "width": 994,
        "height": 659
      },
      "amenity_image_alt_text": "24-Hour Package Lockers at Bishop's Court Apartments, Rancho Cordova",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_00dd007c51103dac6e7f4b9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "yardi",
      "external_id": "86393074",
      "title": "Car Wash Areas with Car Cleaning Kit",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_21b62147d0553a4643e09bd0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "yardi",
      "external_id": "80428573",
      "title": "Resident Activity Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_427cf2e567edf43d56f833a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "yardi",
      "external_id": "82390127",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bb5169f42f8cd950d56cdce3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "yardi",
      "external_id": "82390128",
      "title": "Online Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_611acb4599e860ee3b786007",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "yardi",
      "external_id": "86393076",
      "title": "Flexible Lease Terms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_80249392f3b6e1534021b07f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "yardi",
      "external_id": "86393077",
      "title": "Smoke Free Housing",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_171ac677116752da801e4917",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "yardi",
      "external_id": "80428575",
      "title": "Se Habla Espanol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_340d03413ba2ac38ed33ff08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "yardi",
      "external_id": "80428578",
      "title": "In-Unit Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019f1737-1f8b-711f-b89e-88a80e8bebef.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with white cabinets, black refrigerator, stove, sink, and dishwasher.",
        "public_id": "019f1737-1f8b-711f-b89e-88a80e8bebef",
        "storage_key": "property/6767906449166883/019f1737-1f8b-711f-b89e-88a80e8bebef.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "A kitchen with black appliances and white cabinets at Bishop's Court Apartments, California, 95670",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1fdeb03363deb2d93c3510d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "yardi",
      "external_id": "80428576",
      "title": "Central Heating and Air",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8d94fa3ffeeafeea642a0fe5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "yardi",
      "external_id": "80428580",
      "title": "Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1558887b8fe6a2a6b537fb7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "yardi",
      "external_id": "80428577",
      "title": "Closet Organizers",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a4b31cd16119148f368be99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "yardi",
      "external_id": "80428571",
      "title": "Spacious Kitchens",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019f1736-e08b-706d-8775-947a9605ff38.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with white cabinets, granite countertops, and black appliances.",
        "public_id": "019f1736-e08b-706d-8775-947a9605ff38",
        "storage_key": "property/6767906449166883/019f1736-e08b-706d-8775-947a9605ff38.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "A kitchen with white cabinets and a black stove top.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_21ff2cdfb9ec3804351e0606",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "yardi",
      "external_id": "87310394",
      "title": "Patio or Deck",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d4a61-91a3-74c3-9cde-7e368798bde1.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green trees and grass.",
        "public_id": "019d4a61-91a3-74c3-9cde-7e368798bde1",
        "storage_key": "property/6767906449166883/019d4a61-91a3-74c3-9cde-7e368798bde1.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "building exterior view and decks at Bishop's Court Apartments, CA 95670",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fcaad7e8faae3ce51990b0ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "yardi",
      "external_id": "80683698",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8af0f1151e0b96464d295f13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "yardi",
      "external_id": "89410740",
      "title": "End Unit - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d8358903a814dfcadd44a50d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "yardi",
      "external_id": "80683699",
      "title": "Oversized Bathrooms - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019f1c50-68b1-762a-ae2b-59b66d250ef1.webp",
      "amenity_image_media": {
        "alt_text": "Bright and clean bathroom with a bathtub, shower, sink, and toilet.",
        "public_id": "019f1c50-68b1-762a-ae2b-59b66d250ef1",
        "storage_key": "property/6767906449166883/019f1c50-68b1-762a-ae2b-59b66d250ef1.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "A bathroom with a toilet, sink, and shower at Bishop's Court Apartments, California, 95670",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_9419b194825c347c9a1301f5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019f1736-e08b-706d-8775-947a9605ff38.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, granite countertops, and black appliances.",
        "public_id": "019f1736-e08b-706d-8775-947a9605ff38",
        "storage_key": "property/6767906449166883/019f1736-e08b-706d-8775-947a9605ff38.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring white cabinetry, sleek granite countertops, and a full suite of black appliances, perfect for home-cooked meals.",
      "link": "false",
      "alt_text": "Kitchen with white cabinets, granite countertops, and black appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_Model1x1Kitchen.jpg"
    },
    {
      "id": "ec_99890fe47d52e41066575da1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019f1737-1f8b-711f-b89e-88a80e8bebef.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, black refrigerator, stove, sink, and dishwasher.",
        "public_id": "019f1737-1f8b-711f-b89e-88a80e8bebef",
        "storage_key": "property/6767906449166883/019f1737-1f8b-711f-b89e-88a80e8bebef.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "A charming kitchen featuring white cabinetry, a black refrigerator, a stove, a double sink, and a dishwasher, perfect for preparing meals.",
      "link": "false",
      "alt_text": "Kitchen with white cabinets, black refrigerator, stove, sink, and dishwasher.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_Model1x1KitchenLaundry.jpg"
    },
    {
      "id": "ec_4f24ddfdcfb2e3ba0f9288c8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019f1737-12f2-716d-b749-8286b9312f7c.webp",
      "image_media": {
        "alt_text": "Kitchen with a dining area featuring two chairs and a glass table.",
        "public_id": "019f1737-12f2-716d-b749-8286b9312f7c",
        "storage_key": "property/6767906449166883/019f1737-12f2-716d-b749-8286b9312f7c.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Enjoy meals in the charming dining area adjacent to the kitchen, perfect for intimate dinners.",
      "link": "false",
      "alt_text": "Kitchen with a dining area featuring two chairs and a glass table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_Model1x1DiningRoom.jpg"
    },
    {
      "id": "ec_507d5f921d500207d6367863",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019f1737-3f1f-7595-9ada-5fa58b841035.webp",
      "image_media": {
        "alt_text": "Kitchen and living room area in an apartment.",
        "public_id": "019f1737-3f1f-7595-9ada-5fa58b841035",
        "storage_key": "property/6767906449166883/019f1737-3f1f-7595-9ada-5fa58b841035.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Modern kitchen with black appliances and granite countertops, flowing into a comfortable living room with a sofa and patio access.",
      "link": "false",
      "alt_text": "Kitchen and living room area in an apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_Model1x1KitchenLivingRoom.jpg"
    },
    {
      "id": "ec_1942d326a63b6c9ae59ab556",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019f1737-1a04-706b-aaaa-26f91c425fd5.webp",
      "image_media": {
        "alt_text": "Living room with white sofa, armchair, coffee table, and sliding glass doors to a balcony.",
        "public_id": "019f1737-1a04-706b-aaaa-26f91c425fd5",
        "storage_key": "property/6767906449166883/019f1737-1a04-706b-aaaa-26f91c425fd5.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Bright and airy living room featuring comfortable seating, a coffee table, and access to a private balcony. Perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Living room with white sofa, armchair, coffee table, and sliding glass doors to a balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_Model1x1LivingRoomPatio.jpg"
    },
    {
      "id": "ec_7e5d0e9670fa894070f373af",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019f1737-3a24-738e-b954-20103eb755cb.webp",
      "image_media": {
        "alt_text": "Living room with white sofa, accent chair, coffee table, and sliding glass door to balcony.",
        "public_id": "019f1737-3a24-738e-b954-20103eb755cb",
        "storage_key": "property/6767906449166883/019f1737-3a24-738e-b954-20103eb755cb.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable white sofa, accent chair, and a coffee table. Enjoy natural light and access to a balcony through the sliding glass doors.",
      "link": "false",
      "alt_text": "Living room with white sofa, accent chair, coffee table, and sliding glass door to balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_Model1x1LivingRoomEntry.jpg"
    },
    {
      "id": "ec_db82689664483371ccdfdb7e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019f1737-83e4-7033-9668-155f6caf2563.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, lamp, and mirrored closet doors.",
        "public_id": "019f1737-83e4-7033-9668-155f6caf2563",
        "storage_key": "property/6767906449166883/019f1737-83e4-7033-9668-155f6caf2563.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Rest easy in our spacious bedrooms, featuring comfortable queen-size beds, ample closet space, and a cozy ambiance.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, nightstand, lamp, and mirrored closet doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_Model1x1Bedroom.jpg"
    },
    {
      "id": "ec_5d2101d31d9f34a1a1e898b9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019f1737-a2b5-7119-b9a9-d3197095e98b.webp",
      "image_media": {
        "alt_text": "Bathroom with a toilet, shower, and vanity.",
        "public_id": "019f1737-a2b5-7119-b9a9-d3197095e98b",
        "storage_key": "property/6767906449166883/019f1737-a2b5-7119-b9a9-d3197095e98b.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "A clean and well-maintained bathroom featuring a toilet, shower with a decorative curtain, and a vanity with a sink and mirror.",
      "link": "false",
      "alt_text": "Bathroom with a toilet, shower, and vanity.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_Model1x1Bathroom.jpg"
    },
    {
      "id": "ec_c528cb566eec8917ea5b33ae",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019f1737-96be-73af-a4ab-bd45df5c6360.webp",
      "image_media": {
        "alt_text": "Kitchen with black stove and refrigerator, white cabinets, and dark granite countertops.",
        "public_id": "019f1737-96be-73af-a4ab-bd45df5c6360",
        "storage_key": "property/6767906449166883/019f1737-96be-73af-a4ab-bd45df5c6360.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Prepare your favorite meals in this spacious kitchen, featuring ample cabinet space, a dishwasher, and a full-size refrigerator.",
      "link": "false",
      "alt_text": "Kitchen with black stove and refrigerator, white cabinets, and dark granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_Model2x1Kitchen.jpg"
    },
    {
      "id": "ec_a2402f4f2478cc38af5b9ee5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019f1737-a71c-714d-a812-34a5687f536b.webp",
      "image_media": {
        "alt_text": "Kitchen with black appliances and white cabinets.",
        "public_id": "019f1737-a71c-714d-a812-34a5687f536b",
        "storage_key": "property/6767906449166883/019f1737-a71c-714d-a812-34a5687f536b.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring black appliances, white cabinetry, and granite countertops. Includes a dishwasher, stove, refrigerator, and sink.",
      "link": "false",
      "alt_text": "Kitchen with black appliances and white cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_Model2x1KitchenLaundry.jpg"
    },
    {
      "id": "ec_cb2a5687775a6f82cd9bcb2f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019f1737-afa5-752d-afe4-929939aec524.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with a dark wood table and chairs, white cabinets, and black appliances.",
        "public_id": "019f1737-afa5-752d-afe4-929939aec524",
        "storage_key": "property/6767906449166883/019f1737-afa5-752d-afe4-929939aec524.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "A spacious kitchen and dining area featuring white cabinets, granite countertops, and a dining table set for four. Perfect for enjoying meals at home.",
      "link": "false",
      "alt_text": "Kitchen and dining area with a dark wood table and chairs, white cabinets, and black appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_Model2x1DiningRoom.jpg"
    },
    {
      "id": "ec_ab2e61c0065db062c49e676f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019f1737-fc9a-7619-a2f7-eae03ac08bd7.webp",
      "image_media": {
        "alt_text": "Kitchen and living area with blue sofa, coffee table, and patio view.",
        "public_id": "019f1737-fc9a-7619-a2f7-eae03ac08bd7",
        "storage_key": "property/6767906449166883/019f1737-fc9a-7619-a2f7-eae03ac08bd7.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Open-concept living space featuring a modern kitchen with black appliances and a view into the living room and patio area.",
      "link": "false",
      "alt_text": "Kitchen and living area with blue sofa, coffee table, and patio view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_Model2x1KitchenLivingRoom.jpg"
    },
    {
      "id": "ec_2b4345b5f283ff88f481dc5b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019f1737-fe51-763f-a85f-34698aa9fad6.webp",
      "image_media": {
        "alt_text": "Living room with blue sofa, coffee table, and balcony view.",
        "public_id": "019f1737-fe51-763f-a85f-34698aa9fad6",
        "storage_key": "property/6767906449166883/019f1737-fe51-763f-a85f-34698aa9fad6.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious living room with comfortable seating, large sliding glass doors, and a private balcony perfect for relaxation.",
      "link": "false",
      "alt_text": "Living room with blue sofa, coffee table, and balcony view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_Model2x1LivingRoomPatio.jpg"
    },
    {
      "id": "ec_87a0bf561769757c84c601d6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019f1738-2bd1-77cc-af34-2aa6555ac3d1.webp",
      "image_media": {
        "alt_text": "Living room with a blue sofa, coffee table, and sliding glass doors leading to a patio.",
        "public_id": "019f1738-2bd1-77cc-af34-2aa6555ac3d1",
        "storage_key": "property/6767906449166883/019f1738-2bd1-77cc-af34-2aa6555ac3d1.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable blue sofa, elegant coffee table, and natural light from sliding doors that open to a private patio.",
      "link": "false",
      "alt_text": "Living room with a blue sofa, coffee table, and sliding glass doors leading to a patio.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_Model2x1LivingRoomSideAngle.jpg"
    },
    {
      "id": "ec_cba6b032c1b46c27af4710e4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019f1738-0ab8-7656-98cd-c24327920ca5.webp",
      "image_media": {
        "alt_text": "Spacious living and dining area with a blue sofa, coffee table, and dining set.",
        "public_id": "019f1738-0ab8-7656-98cd-c24327920ca5",
        "storage_key": "property/6767906449166883/019f1738-0ab8-7656-98cd-c24327920ca5.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this inviting apartment, featuring a stylish living area with a plush blue sofa and a separate dining space perfect for meals.",
      "link": "false",
      "alt_text": "Spacious living and dining area with a blue sofa, coffee table, and dining set.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_Model2x1LivingRoomDiningRoom.jpg"
    },
    {
      "id": "ec_c088bc4c80859e8b395ec48e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019f1738-171e-734e-a4d4-5514937e23c3.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, and closet",
        "public_id": "019f1738-171e-734e-a4d4-5514937e23c3",
        "storage_key": "property/6767906449166883/019f1738-171e-734e-a4d4-5514937e23c3.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, elegant dresser, and ample closet space.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, dresser, and closet",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_Model2x1PrimaryBedroom.jpg"
    },
    {
      "id": "ec_adf449ec7c28035b0fc2cf51",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019f1738-811c-75ea-bda7-1333b831e381.webp",
      "image_media": {
        "alt_text": "Bedroom with dresser, vanity, and closet",
        "public_id": "019f1738-811c-75ea-bda7-1333b831e381",
        "storage_key": "property/6767906449166883/019f1738-811c-75ea-bda7-1333b831e381.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a dark wood dresser, a vanity with a sink, and ample closet space. The room is decorated with a 'love' sign and a decorative vase.",
      "link": "false",
      "alt_text": "Bedroom with dresser, vanity, and closet",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_Model2x1PrimaryRoomVanity.jpg"
    },
    {
      "id": "ec_267f95b0986dcf7bf0f9d112",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019f1738-76b6-751b-94e1-bde2064f85b7.webp",
      "image_media": {
        "alt_text": "A bedroom with a bed, desk, and artwork.",
        "public_id": "019f1738-76b6-751b-94e1-bde2064f85b7",
        "storage_key": "property/6767906449166883/019f1738-76b6-751b-94e1-bde2064f85b7.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Relaxing bedroom featuring a comfortable bed, functional desk space, and decorative artwork.",
      "link": "false",
      "alt_text": "A bedroom with a bed, desk, and artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_Model2x1SecondBedroom.jpg"
    },
    {
      "id": "ec_64d377b17b8887f798d0e668",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019fd08e-aa00-762b-88c1-bf7001786463.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white tub-shower combo, green floral shower curtain, and vanity with a granite countertop.",
        "public_id": "019fd08e-aa00-762b-88c1-bf7001786463",
        "storage_key": "property/6767906449166883/019fd08e-aa00-762b-88c1-bf7001786463.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Step into comfort with this beautifully appointed bathroom, featuring a pristine white tub-shower combo and elegant green floral accents. The granite countertop vanity offers ample space for your daily routine.",
      "link": "false",
      "alt_text": "Modern bathroom with a white tub-shower combo, green floral shower curtain, and vanity with a granite countertop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_Model2x1Bathroom.jpg"
    },
    {
      "id": "ec_2956027bc7763939872ac20e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d42a1-824e-739f-bf1a-9dc568de6a6a.webp",
      "image_media": {
        "alt_text": "Swimming pool area with blue lounge chairs and umbrellas.",
        "public_id": "019d42a1-824e-739f-bf1a-9dc568de6a6a",
        "storage_key": "property/6767906449166883/019d42a1-824e-739f-bf1a-9dc568de6a6a.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, complete with ample lounge seating and shade umbrellas for your comfort.",
      "link": "false",
      "alt_text": "Swimming pool area with blue lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_SwimmingPoolDeck.jpg"
    },
    {
      "id": "ec_1b534615347c5a72310c7be4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d497e-bcac-76ce-88a6-de2eae457845.webp",
      "image_media": {
        "alt_text": "Swimming pool and hot tub area with lounge chairs and umbrellas.",
        "public_id": "019d497e-bcac-76ce-88a6-de2eae457845",
        "storage_key": "property/6767906449166883/019d497e-bcac-76ce-88a6-de2eae457845.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool or relax in the soothing hot tub, surrounded by lush landscaping and comfortable lounge seating.",
      "link": "false",
      "alt_text": "Swimming pool and hot tub area with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_SwimmingPoolSpaView.jpg"
    },
    {
      "id": "ec_91b75f8ad4c22eee4548b1b1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d4968-58f3-76ed-a84f-28f8c3ef0304.webp",
      "image_media": {
        "alt_text": "Refreshing swimming pool with lounge chairs and umbrellas on a sunny day.",
        "public_id": "019d4968-58f3-76ed-a84f-28f8c3ef0304",
        "storage_key": "property/6767906449166883/019d4968-58f3-76ed-a84f-28f8c3ef0304.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling swimming pool, complete with comfortable lounge chairs and ample shade. Perfect for enjoying sunny days and cooling off.",
      "link": "false",
      "alt_text": "Refreshing swimming pool with lounge chairs and umbrellas on a sunny day.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_SwimmingPoolSideView.jpg"
    },
    {
      "id": "ec_6f48a508c08538a6a00d284c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d4968-925f-740c-8849-c298ffcca482.webp",
      "image_media": {
        "alt_text": "Apartment complex swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d4968-925f-740c-8849-c298ffcca482",
        "storage_key": "property/6767906449166883/019d4968-925f-740c-8849-c298ffcca482.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool, complete with comfortable lounge chairs and ample shade from large umbrellas.",
      "link": "false",
      "alt_text": "Apartment complex swimming pool with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_SwimmingPoolFurniture.jpg"
    },
    {
      "id": "ec_5b848423b3383064fe27f1c4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d4968-5837-75aa-b021-cd65647dd45e.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with tables and chairs under a pergola, adjacent to apartment buildings.",
        "public_id": "019d4968-5837-75aa-b021-cd65647dd45e",
        "storage_key": "property/6767906449166883/019d4968-5837-75aa-b021-cd65647dd45e.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy relaxing outdoors in our community's shaded seating area, perfect for socializing or enjoying a quiet moment.",
      "link": "false",
      "alt_text": "Outdoor seating area with tables and chairs under a pergola, adjacent to apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_SwimmingPoolArborLounge.jpg"
    },
    {
      "id": "ec_bb44df9a6693a39c436f3fcd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d497e-bc36-762c-a89a-9c6e68dd9217.webp",
      "image_media": {
        "alt_text": "Gym equipment in a community clubhouse with a large stone fireplace.",
        "public_id": "019d497e-bc36-762c-a89a-9c6e68dd9217",
        "storage_key": "property/6767906449166883/019d497e-bc36-762c-a89a-9c6e68dd9217.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Stay active in our well-equipped fitness center, featuring modern exercise machines and a cozy stone fireplace.",
      "link": "false",
      "alt_text": "Gym equipment in a community clubhouse with a large stone fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_FitnessCenterMachines.jpg"
    },
    {
      "id": "ec_40bb385f1d6c6261f3c6dcf8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d497e-be28-71b3-b597-1221509b0a7b.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, and weight machines.",
        "public_id": "019d497e-be28-71b3-b597-1221509b0a7b",
        "storage_key": "property/6767906449166883/019d497e-be28-71b3-b597-1221509b0a7b.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Stay active and healthy in our fully-equipped fitness center, featuring a variety of cardio and strength training equipment for a complete workout.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, elliptical, and weight machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_FitnessCenterStrengthEquipment.jpg"
    },
    {
      "id": "ec_74e6eb61274ecaf5a9f3faad",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d497e-bbd4-7751-a7a8-0a64f29570e4.webp",
      "image_media": {
        "alt_text": "Gym with cardio machines and weight training equipment.",
        "public_id": "019d497e-bbd4-7751-a7a8-0a64f29570e4",
        "storage_key": "property/6767906449166883/019d497e-bbd4-7751-a7a8-0a64f29570e4.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring treadmills, stair climbers, and weight machines for a complete workout.",
      "link": "false",
      "alt_text": "Gym with cardio machines and weight training equipment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_FitnessCenterSideView.jpg"
    },
    {
      "id": "ec_685e3e1a336df5f67413655d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d4a61-5c39-735e-b7d7-685e84a6e6d1.webp",
      "image_media": {
        "alt_text": "Playground equipment with slides and climbing structures in front of apartment buildings.",
        "public_id": "019d4a61-5c39-735e-b7d7-685e84a6e6d1",
        "storage_key": "property/6767906449166883/019d4a61-5c39-735e-b7d7-685e84a6e6d1.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy the on-site playground, perfect for family fun and outdoor recreation.",
      "link": "false",
      "alt_text": "Playground equipment with slides and climbing structures in front of apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_PlayStructure.jpg"
    },
    {
      "id": "ec_5044a9dc2a2fb2360a325632",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d4a61-95f3-770e-915c-86ade372e4c6.webp",
      "image_media": {
        "alt_text": "Playground with slides and tunnels, picnic table, and trash can.",
        "public_id": "019d4a61-95f3-770e-915c-86ade372e4c6",
        "storage_key": "property/6767906449166883/019d4a61-95f3-770e-915c-86ade372e4c6.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the community playground, complete with slides and tunnels, plus picnic tables for family gatherings.",
      "link": "false",
      "alt_text": "Playground with slides and tunnels, picnic table, and trash can.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_PlaygroundPicnicTable.jpg"
    },
    {
      "id": "ec_2040f03e1bd267191d9b31ba",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d4a61-4a38-73ed-a186-5fe5dc845b82.webp",
      "image_media": {
        "alt_text": "Exterior view of the apartment buildings with lush greenery and a paved pathway.",
        "public_id": "019d4a61-4a38-73ed-a186-5fe5dc845b82",
        "storage_key": "property/6767906449166883/019d4a61-4a38-73ed-a186-5fe5dc845b82.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Discover comfortable living at our apartment complex, featuring well-maintained exteriors surrounded by beautiful landscaping and serene courtyards.",
      "link": "false",
      "alt_text": "Exterior view of the apartment buildings with lush greenery and a paved pathway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_BuildingExteriorDirectionalSign.jpg"
    },
    {
      "id": "ec_c2fcf3df70d7e2d748735a3f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d4a61-1af7-746a-9234-6446473f347c.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a walkway and landscaping.",
        "public_id": "019d4a61-1af7-746a-9234-6446473f347c",
        "storage_key": "property/6767906449166883/019d4a61-1af7-746a-9234-6446473f347c.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Charming exterior view of apartment buildings, featuring a well-maintained walkway and lush greenery, creating a welcoming atmosphere.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with a walkway and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_BuildingExteriorLandscaping.jpg"
    },
    {
      "id": "ec_0cc7c4498103e1da2f864f49",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d4a61-8940-7707-858b-49038971121e.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with green landscaping and trees.",
        "public_id": "019d4a61-8940-7707-858b-49038971121e",
        "storage_key": "property/6767906449166883/019d4a61-8940-7707-858b-49038971121e.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Beautifully landscaped grounds with modern apartment buildings offer a serene living environment.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with green landscaping and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_BuildingExteriorGreenSpaces.jpg"
    },
    {
      "id": "ec_80d897c9a958b35123708a91",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d4a61-91a3-74c3-9cde-7e368798bde1.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with lush green trees and grass.",
        "public_id": "019d4a61-91a3-74c3-9cde-7e368798bde1",
        "storage_key": "property/6767906449166883/019d4a61-91a3-74c3-9cde-7e368798bde1.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Charming apartment buildings surrounded by mature trees and manicured lawns, offering a serene living environment.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with lush green trees and grass.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_BuildingExteriorDecks.jpg"
    },
    {
      "id": "ec_79f5747dc63b5ed4c3443897",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d4a61-8039-743e-9cb8-50d470ea371b.webp",
      "image_media": {
        "alt_text": "Row of garage doors with manicured landscaping.",
        "public_id": "019d4a61-8039-743e-9cb8-50d470ea371b",
        "storage_key": "property/6767906449166883/019d4a61-8039-743e-9cb8-50d470ea371b.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Secure and convenient garage parking available for residents. Covered parking ensures your vehicle stays protected from the elements.",
      "link": "false",
      "alt_text": "Row of garage doors with manicured landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/BishopsCourt_RanchoCordova_CA_GaragesParkingLot.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_9bedf33f-2469-4ca0-add1-7640149cab9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "Hibachi Buffet, Sushi & Grill",
      "poi_type": "Restaurants",
      "poi_address": "5623 Sunrise Blvd, Citrus Heights, CA 95610, USA",
      "poi_short_description": "Budget eatery featuring a large variety of Japanese and Asian dishes, including sushi and pizza, as well as a hibachi grill.",
      "poi_long_description": "People say this buffet restaurant offers a wide variety of fresh seafood, sushi, and grilled dishes, including frog legs and garlic crabs. They also highlight the reasonable prices, the fun hibachi grill, and the friendly, attentive staff who quickly clear plates and refill drinks.\n\nOther reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-c751-77bf-a048-3e520b83f293.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-c751-77bf-a048-3e520b83f293",
        "storage_key": "property/6767906449166883/019d08ab-c751-77bf-a048-3e520b83f293.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://hibachibuffetsacramento.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10003753580362333522&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hibachi-buffet-sushi--grill",
      "poi_latitude": "38.6682741",
      "poi_longitude": "-121.2729759",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 916-961-1508",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-6c0b-75b1-9b66-05e27ed2057e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-6c0b-75b1-9b66-05e27ed2057e",
        "storage_key": "property/6767906449166883/019d08ab-6c0b-75b1-9b66-05e27ed2057e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ09bAx4TfmoARUv0JEuF41Io",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_474d7fb6-b600-4cb4-8e25-711a42ade04b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "2475 Sunrise Blvd, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "People say this hamburger restaurant serves delicious burgers and animal-style fries. They highlight the good value and fast service. They also like the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-c7b0-7119-896c-b29260c92518.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-c7b0-7119-896c-b29260c92518",
        "storage_key": "property/6767906449166883/019d08ab-c7b0-7119-896c-b29260c92518.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://locations.in-n-out.com/122",
      "poi_directions_map_url": "https://maps.google.com/?cid=7039849622734918187&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "38.6146237",
      "poi_longitude": "-121.2689773",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-6c0b-75b1-9b66-05e27ed2057e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-6c0b-75b1-9b66-05e27ed2057e",
        "storage_key": "property/6767906449166883/019d08ab-6c0b-75b1-9b66-05e27ed2057e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2bAREILdmoARK1JI4-6RsmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_4bd823bb-75fd-43c4-92f4-80170d8b64c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "Oz Korean BBQ - Sacramento",
      "poi_type": "Restaurants",
      "poi_address": "3343 Bradshaw Rd, Sacramento, CA 95827, USA",
      "poi_short_description": "Relaxed eatery featuring all-you-can-eat BBQ and other Korean grilling specialties.",
      "poi_long_description": "People say this Korean barbecue restaurant offers all-you-can-eat bulgogi and other meats, which diners cook themselves on inset table grills. They highlight the competitive pricing, fun atmosphere with a robot server, and the variety of tasty side dishes. They also like the attentive and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-c77b-7658-8250-9e6c9e3db062.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-c77b-7658-8250-9e6c9e3db062",
        "storage_key": "property/6767906449166883/019d08ab-c77b-7658-8250-9e6c9e3db062.webp",
        "width": 1280,
        "height": 833
      },
      "poi_business_url": "http://ozkoreanbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2578335994149626992&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oz-korean-bbq---sacramento",
      "poi_latitude": "38.5635475",
      "poi_longitude": "-121.3355409",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-362-9292",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-6c0b-75b1-9b66-05e27ed2057e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-6c0b-75b1-9b66-05e27ed2057e",
        "storage_key": "property/6767906449166883/019d08ab-6c0b-75b1-9b66-05e27ed2057e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1xxhHbfcmoARcGTkEu0WyCM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "korean_restaurant"
    },
    {
      "id": "custom_4002eee6-2c18-42ae-9834-a7e0eaa64953",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "3348 El Camino Ave, Sacramento, CA 95821, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers, Texas toast, and coleslaw. They also highlight the crispy texture of the chicken and the friendly service.\n\nOther reviews mention the chicken can be soggy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-c6f0-7719-ae71-7b1858a05011.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-c6f0-7719-ae71-7b1858a05011",
        "storage_key": "property/6767906449166883/019d08ab-c6f0-7719-ae71-7b1858a05011.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.raisingcanes.com/ca/sacramento/3348-el-camino-ave",
      "poi_directions_map_url": "https://maps.google.com/?cid=10525750549688943766&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "38.610141",
      "poi_longitude": "-121.3842577",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 916-490-4587",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-6c0b-75b1-9b66-05e27ed2057e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-6c0b-75b1-9b66-05e27ed2057e",
        "storage_key": "property/6767906449166883/019d08ab-6c0b-75b1-9b66-05e27ed2057e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf5XVyNTbmoARlgSVbFv6EpI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_48c4172f-4a12-4bae-a74b-8109918ac008",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "Dave's Hot Chicken",
      "poi_type": "Restaurants",
      "poi_address": "3409 Arden Way, Sacramento, CA 95825, USA",
      "poi_short_description": "Laid-back chain serving a compact menu of hot-chicken tenders and sliders (including cauliflower options), plus fries and sauces.",
      "poi_long_description": "People say this chicken restaurant serves delicious chicken sliders, tenders, and fries. They highlight the quick service, friendly staff, and clean environment. They also like the generous portions of pickles and the option to choose spice levels.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-cfec-75ff-99b6-ca6f8f066eaa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-cfec-75ff-99b6-ca6f8f066eaa",
        "storage_key": "property/6767906449166883/019d08ab-cfec-75ff-99b6-ca6f8f066eaa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.daveshotchicken.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2100344108989499508&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "daves-hot-chicken",
      "poi_latitude": "38.5961783",
      "poi_longitude": "-121.3847769",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 916-993-3370",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-6c0b-75b1-9b66-05e27ed2057e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-6c0b-75b1-9b66-05e27ed2057e",
        "storage_key": "property/6767906449166883/019d08ab-6c0b-75b1-9b66-05e27ed2057e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZfyj06bbmoARdEhnytbrJR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_e8e1ffeb-7485-479f-8766-cc09ec39652f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "KP International Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "10971 Olson Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Large grocery with a food court selling a wide selection of international products.",
      "poi_long_description": "People say this grocery store offers a wide variety of international products, including Asian, German, Mexican, Korean, Middle Eastern, African, Russian, and Indian foods, as well as fresh produce, seafood, and bakery items. They also highlight the reasonable prices, the large selection of meats and deli items, and the convenient food court with a variety of Asian cuisines.\n\nOther reviews mention the store can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-d02b-770c-afa1-5937cd817d8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-d02b-770c-afa1-5937cd817d8f",
        "storage_key": "property/6767906449166883/019d08ab-d02b-770c-afa1-5937cd817d8f.webp",
        "width": 754,
        "height": 378
      },
      "poi_business_url": "https://sac.kpmart.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15187449826825008127&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kp-international-market",
      "poi_latitude": "38.596949",
      "poi_longitude": "-121.2834325",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 916-853-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-7297-74cd-8bee-ae1db2c2d737.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-7297-74cd-8bee-ae1db2c2d737",
        "storage_key": "property/6767906449166883/019d08ab-7297-74cd-8bee-ae1db2c2d737.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ53wh7GzdmoAR__P4oyapxNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_7bf8b31e-c7c5-4fe2-86ab-ffff15e00f1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "WFM Coffee Bar",
      "poi_type": "Shopping & Retail",
      "poi_address": "4315 Arden Way, Sacramento, CA 95864, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh, organic produce and healthy food choices. They also highlight the friendly and helpful staff, and the clean and pleasant shopping experience.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-d1f2-7640-9228-da0259c8b7e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-d1f2-7640-9228-da0259c8b7e9",
        "storage_key": "property/6767906449166883/019d08ab-d1f2-7640-9228-da0259c8b7e9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.wholefoodsmarket.com/stores/sacramento?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=6874909360727790268&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wfm-coffee-bar",
      "poi_latitude": "38.5966181",
      "poi_longitude": "-121.363738",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 916-488-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-7297-74cd-8bee-ae1db2c2d737.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-7297-74cd-8bee-ae1db2c2d737",
        "storage_key": "property/6767906449166883/019d08ab-7297-74cd-8bee-ae1db2c2d737.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc2XZlY_bmoARvBIwhaOVaF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b9ed3d59-9f09-4df8-a036-885579b01265",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "2300 Watt Ave, Sacramento, CA 95825, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "People say this grocery store offers a wide selection of products, including bulk items, produce, and meat. They also highlight the low prices, great deals, and significant savings, as well as the friendly and helpful staff.\n\nOther reviews mention the checkout lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-d219-7184-bc55-ef56643f3dcb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-d219-7184-bc55-ef56643f3dcb",
        "storage_key": "property/6767906449166883/019d08ab-d219-7184-bc55-ef56643f3dcb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12825324731443177216&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "38.6073105",
      "poi_longitude": "-121.3817608",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 916-246-5370",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-7297-74cd-8bee-ae1db2c2d737.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-7297-74cd-8bee-ae1db2c2d737",
        "storage_key": "property/6767906449166883/019d08ab-7297-74cd-8bee-ae1db2c2d737.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl8X1bMPbmoARAOezSuS0_LE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_9535b3a7-3368-4373-b44b-5fc27877d517",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "6001 Madison Ave, Carmichael, CA 95608, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store is well-stocked with a wide variety of products, and the staff are friendly, helpful, and knowledgeable. They also highlight the convenient location and efficient checkout process.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-d8d9-776b-96a2-dc7feb274a2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-d8d9-776b-96a2-dc7feb274a2a",
        "storage_key": "property/6767906449166883/019d08ab-d8d9-776b-96a2-dc7feb274a2a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/Carmichael/CA/Carmichael/95608/650?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=10135906078489022522&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "38.6627218",
      "poi_longitude": "-121.3260026",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 916-344-9600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-73ec-75be-9ad5-beb9f381876c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-73ec-75be-9ad5-beb9f381876c",
        "storage_key": "property/6767906449166883/019d08ab-73ec-75be-9ad5-beb9f381876c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgUYk1O7emoAROpAPReD4qYw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_e29686f6-d579-40a4-898b-005788a736e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "5309 Sunrise Blvd, Fair Oaks, CA 95628, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, unique items, and healthy food options, including a variety of vegetarian, chicken, and seafood dishes. They highlight the affordable prices, especially for organic fruits, vegetables, eggs, and chicken, and the great value for fresh flowers and indoor plants. They also like the friendly and helpful staff, and the pleasant shopping experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-d900-70e8-bb3a-6236b15ca17b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-d900-70e8-bb3a-6236b15ca17b",
        "storage_key": "property/6767906449166883/019d08ab-d900-70e8-bb3a-6236b15ca17b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.traderjoes.com/ca/fair-oaks/71/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=9752620037659171511&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "38.6620665",
      "poi_longitude": "-121.2738677",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 916-863-1744",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-7297-74cd-8bee-ae1db2c2d737.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-7297-74cd-8bee-ae1db2c2d737",
        "storage_key": "property/6767906449166883/019d08ab-7297-74cd-8bee-ae1db2c2d737.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBw4N9hremoARtxoIrkBEWIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_1e616da3-7b1c-49ed-867e-f8f184984b49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "American River College",
      "poi_type": "Education",
      "poi_address": "4700 College Oak Dr, Sacramento, CA 95841, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-d9d9-7398-b5ab-7a07d675aa0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-d9d9-7398-b5ab-7a07d675aa0b",
        "storage_key": "property/6767906449166883/019d08ab-d9d9-7398-b5ab-7a07d675aa0b.webp",
        "width": 1280,
        "height": 813
      },
      "poi_business_url": "https://arc.losrios.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1010375658575580987&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "american-river-college",
      "poi_latitude": "38.6511479",
      "poi_longitude": "-121.3467327",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 916-484-8011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-73ea-744e-8fb4-d2aab26f4575.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-73ea-744e-8fb4-d2aab26f4575",
        "storage_key": "property/6767906449166883/019d08ab-73ea-744e-8fb4-d2aab26f4575.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJS44sh8nemoARO08Z606TBQ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_821df2b0-7a15-4218-bcb1-0a7c94aa3af1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "Sacramento Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "2701 Prospect Park Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Open since 2011, a museum for kids aged 8 and under which runs interactive events & activities.",
      "poi_long_description": "People say this children's museum offers fun activities for kids. They also highlight the good price and plentiful, free parking.\n\nSome reviews mention the museum can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-0dbf-73ef-a182-75407e8b7255.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-0dbf-73ef-a182-75407e8b7255",
        "storage_key": "property/6767906449166883/019d08ab-0dbf-73ef-a182-75407e8b7255.webp",
        "width": 1280,
        "height": 984
      },
      "poi_business_url": "http://www.sackids.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15104424772155538293&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-childrens-museum",
      "poi_latitude": "38.5888889",
      "poi_longitude": "-121.2838889",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 916-730-5079",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-794b-74af-b548-439a50cc10e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-794b-74af-b548-439a50cc10e9",
        "storage_key": "property/6767906449166883/019d08ab-794b-74af-b548-439a50cc10e9.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2WM0IQPamoARdfvwuE2yndE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_b4c05c4a-919d-4017-bece-5d3572d3b4a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "Rebounderz Sacramento - Indoor Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "2401 Butano Dr, Sacramento, CA 95825, USA",
      "poi_short_description": "Trampoline park with climbing walls, arcade games and a ninja course, plus free WiFi.",
      "poi_long_description": "People say this amusement park offers a variety of play areas, structures, and video games, as well as an arcade with prizes. They also highlight the friendly and attentive staff, and the positive and fun vibe.\n\nSome reviews mention there can be safety hazards.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-dcb3-71d1-b7bc-2dc06fef2f9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-dcb3-71d1-b7bc-2dc06fef2f9f",
        "storage_key": "property/6767906449166883/019d08ab-dcb3-71d1-b7bc-2dc06fef2f9f.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://www.rebounderz.com/city/sacramento/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13746415684359926292&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rebounderz-sacramento---indoor-trampoline-and-adventure-park",
      "poi_latitude": "38.6078872",
      "poi_longitude": "-121.3804779",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 916-829-8969",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-6c0c-71df-b110-0cf125a103d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-6c0c-71df-b110-0cf125a103d1",
        "storage_key": "property/6767906449166883/019d08ab-6c0c-71df-b110-0cf125a103d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJadAv-MXbmoARFLIhuTsUxb4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_a8593f89-41cd-4b06-b541-6d467d2bd4f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "White Rock Neighborhood Splash Park",
      "poi_type": "Entertainment",
      "poi_address": "10488 White Rock Rd A, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Playful water park featuring 2 slides, a bucket and other features, plus a clean playground.",
      "poi_long_description": "People say this water park offers fun slides and splash features, including giant dumping buckets. They also highlight the unbeatable price, family-friendly atmosphere, and clean, safe, and well-designed layout.\n\nOther reviews mention the slides can be an additional cost.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-e1ae-75ca-9225-f138d6be5ab8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-e1ae-75ca-9225-f138d6be5ab8",
        "storage_key": "property/6767906449166883/019d08ab-e1ae-75ca-9225-f138d6be5ab8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://cordovarpd.gov/parks/white-rock-splash-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4696759076083854131&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "white-rock-neighborhood-splash-park",
      "poi_latitude": "38.5852927",
      "poi_longitude": "-121.3002919",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-6c0c-71df-b110-0cf125a103d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-6c0c-71df-b110-0cf125a103d1",
        "storage_key": "property/6767906449166883/019d08ab-6c0c-71df-b110-0cf125a103d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeR-oeyLdmoARM-uRxX49LkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_5bc29441-a7f5-428c-8c71-d056293c588a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "ARC Stadium",
      "poi_type": "Entertainment",
      "poi_address": "4700 College Oak Dr, Sacramento, CA 95841, USA",
      "poi_short_description": "Stadium with a track and field, hosting baseball games and other events.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-e26d-7169-8c93-00a48548d36a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-e26d-7169-8c93-00a48548d36a",
        "storage_key": "property/6767906449166883/019d08ab-e26d-7169-8c93-00a48548d36a.webp",
        "width": 1280,
        "height": 752
      },
      "poi_business_url": "http://arc.losrios.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8904538000052726170&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "arc-stadium",
      "poi_latitude": "38.6466506",
      "poi_longitude": "-121.3478243",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 916-484-8011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ac-1bbf-770b-bc5f-8186a8a12139.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-1bbf-770b-bc5f-8186a8a12139",
        "storage_key": "property/6767906449166883/019d08ac-1bbf-770b-bc5f-8186a8a12139.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJezZADrbemoARmikc_iFGk3s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_4a2e5f3e-ad1b-4bc8-951a-e9d69a0ec74a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "Swanston Water Park",
      "poi_type": "Entertainment",
      "poi_address": "2388-2398 Northrop Ave, Sacramento, CA 95825, USA",
      "poi_short_description": "Shady park with playground equipment, basketball courts and picnic tables.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-e4ee-7779-82b0-3928b2c590f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-e4ee-7779-82b0-3928b2c590f8",
        "storage_key": "property/6767906449166883/019d08ab-e4ee-7779-82b0-3928b2c590f8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.morpd.com/swanston-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=8762399147102367451&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "swanston-water-park",
      "poi_latitude": "38.5807054",
      "poi_longitude": "-121.407426",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 916-333-6464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-6c0c-71df-b110-0cf125a103d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-6c0c-71df-b110-0cf125a103d1",
        "storage_key": "property/6767906449166883/019d08ab-6c0c-71df-b110-0cf125a103d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa5NrlFHamoAR2-44X5lLmnk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_1f1b8175-90d8-41f5-826e-437f09226201",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "VCA Sacramento Veterinary Referral Center",
      "poi_type": "Health and Wellness",
      "poi_address": "9801 Old Winery Pl, Sacramento, CA 95827, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-eeac-7327-8ff2-72699bc3ae77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-eeac-7327-8ff2-72699bc3ae77",
        "storage_key": "property/6767906449166883/019d08ab-eeac-7327-8ff2-72699bc3ae77.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://vcahospitals.com/sacramento-veterinary-referral-center?utm_source=maps&utm_medium=organic&utm_campaign=AU_595",
      "poi_directions_map_url": "https://maps.google.com/?cid=15938789651328108313&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vca-sacramento-veterinary-referral-center",
      "poi_latitude": "38.574361",
      "poi_longitude": "-121.331015",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-362-3111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-6c0c-71df-b110-0cf125a103d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-6c0c-71df-b110-0cf125a103d1",
        "storage_key": "property/6767906449166883/019d08ab-6c0c-71df-b110-0cf125a103d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpwLOfcDcmoARGYcVlb30Md0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_7ed037ae-4c28-4f80-b55a-7d3702d83eab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2400 Watt Ave, Sacramento, CA 95825, USA",
      "poi_short_description": "Health-and-fitness chain offering equipment, 30-minute circuit classes and tanning in an inclusive zone.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-eeab-732d-956e-471e96b2f928.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-eeab-732d-956e-471e96b2f928",
        "storage_key": "property/6767906449166883/019d08ab-eeab-732d-956e-471e96b2f928.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/sacramento-country-club-ca?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=11120778406635775460&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "38.6082699",
      "poi_longitude": "-121.381441",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 916-407-3280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-6c0c-71df-b110-0cf125a103d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-6c0c-71df-b110-0cf125a103d1",
        "storage_key": "property/6767906449166883/019d08ab-6c0c-71df-b110-0cf125a103d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYzIGVdvbmoAR5CVcWQrxVJo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1366fa25-1673-4c23-a08b-90cbe80f32d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "9574 Micron Ave, Sacramento, CA 95827, USA",
      "poi_short_description": "Chain fitness center with strength and cardio equipment, a lap pool, and personal training.",
      "poi_long_description": "People say this gym offers a variety of equipment, including cardio machines, weights, and squash courts, as well as amenities like a sauna and steam room. They also highlight the convenient location, friendly and helpful staff, and positive, inclusive vibe.\n\nSome reviews mention the facilities can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-ef61-7210-ab32-f2a3d714d856.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-ef61-7210-ab32-f2a3d714d856",
        "storage_key": "property/6767906449166883/019d08ab-ef61-7210-ab32-f2a3d714d856.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/sacramento-ca/rancho-cordova-active?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=16351542931293028536&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "38.562658",
      "poi_longitude": "-121.341053",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-363-4382",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-6c0c-71df-b110-0cf125a103d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-6c0c-71df-b110-0cf125a103d1",
        "storage_key": "property/6767906449166883/019d08ab-6c0c-71df-b110-0cf125a103d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT8BMQbDcmoARuEBFbalZ7OI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7ae8f83d-21af-4fd7-ab93-f015e580e15d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "In-Shape Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3350 Arden Way, Sacramento, CA 95825, USA",
      "poi_short_description": "Chain gym offering equipment, classes, and a pool, plus a sauna.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-ef83-731a-bcfe-4891de73fc60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-ef83-731a-bcfe-4891de73fc60",
        "storage_key": "property/6767906449166883/019d08ab-ef83-731a-bcfe-4891de73fc60.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.inshape.com/gyms/watt?utm_source=G&utm_medium=Local&utm_campaign=Google-Local&utm_source=G&utm_medium=Local&utm_campaign=Google-Local",
      "poi_directions_map_url": "https://maps.google.com/?cid=5554373615583185281&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-shape-fitness",
      "poi_latitude": "38.5944565",
      "poi_longitude": "-121.3851682",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 916-359-1775",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-6c0c-71df-b110-0cf125a103d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-6c0c-71df-b110-0cf125a103d1",
        "storage_key": "property/6767906449166883/019d08ab-6c0c-71df-b110-0cf125a103d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhe1EcLnbmoARgUmjAmAZFU0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c29d3cd1-d7c2-43be-9db3-9ffe6a88b794",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "Club Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "5419 Sunrise Blvd, Citrus Heights, CA 95610, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of fitness classes and has great instructors. They also highlight the clean and welcoming environment, and the friendly and motivating staff.\n\nOther reviews mention the management can be unresponsive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-f8b1-778f-a583-bd09148899e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-f8b1-778f-a583-bd09148899e1",
        "storage_key": "property/6767906449166883/019d08ab-f8b1-778f-a583-bd09148899e1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.clubstudiofitness.com/Pages/clubhome.aspx?clubid=1332&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=16002885080850549633&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "club-studio",
      "poi_latitude": "38.6651676",
      "poi_longitude": "-121.2742563",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 916-246-1101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-6c0c-71df-b110-0cf125a103d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-6c0c-71df-b110-0cf125a103d1",
        "storage_key": "property/6767906449166883/019d08ab-6c0c-71df-b110-0cf125a103d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBQVLIwDfmoARgct-sTGrFd4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_86ad3d12-e01f-4a19-ad12-657c6666b126",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "1220 Arden Hills Ln, Sacramento, CA 95864, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of high-quality cardio and resistance machines, free weights, and benches, as well as a pool, sauna, and steam room.\n\nOther reviews mention the facility can be unfinished and the hours can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-f862-7233-a3d7-7c2b1ca4f7b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-f862-7233-a3d7-7c2b1ca4f7b9",
        "storage_key": "property/6767906449166883/019d08ab-f862-7233-a3d7-7c2b1ca4f7b9.webp",
        "width": 1088,
        "height": 1088
      },
      "poi_business_url": "https://www.lifetime.life/locations/ca/arden.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=16318376630873716585&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "38.5882885",
      "poi_longitude": "-121.3550755",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 916-604-5050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-6c0c-71df-b110-0cf125a103d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-6c0c-71df-b110-0cf125a103d1",
        "storage_key": "property/6767906449166883/019d08ab-6c0c-71df-b110-0cf125a103d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUaMku2TbmoARaXdDWhaFduI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_344959dd-04ee-4860-81bd-a5521446e447",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "Tricks Sacramento Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "4440 Marconi Ave #100, Sacramento, CA 95821, USA",
      "poi_short_description": "Laid-back gym for kids, offering gymnastics, dance and fitness classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-f97a-77a9-aeb5-0d4202dfaf47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-f97a-77a9-aeb5-0d4202dfaf47",
        "storage_key": "property/6767906449166883/019d08ab-f97a-77a9-aeb5-0d4202dfaf47.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://tricksgymsac.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4581298134780961097&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tricks-sacramento-gymnastics",
      "poi_latitude": "38.6170997",
      "poi_longitude": "-121.3608639",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 916-481-4496",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-73ea-744e-8fb4-d2aab26f4575.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-73ea-744e-8fb4-d2aab26f4575",
        "storage_key": "property/6767906449166883/019d08ab-73ea-744e-8fb4-d2aab26f4575.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8wojLvrbmoARSWHHfWEKlD8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7bb2e42e-4315-44ed-bd7f-f7b0e578ef70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "Technique Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "11345 Folsom Blvd, Rancho Cordova, CA 95742, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-f989-7113-8bd2-2021647824aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-f989-7113-8bd2-2021647824aa",
        "storage_key": "property/6767906449166883/019d08ab-f989-7113-8bd2-2021647824aa.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.techniquegym.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16931436404873598851&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "technique-gymnastics",
      "poi_latitude": "38.6122779",
      "poi_longitude": "-121.2581024",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-635-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-73ea-744e-8fb4-d2aab26f4575.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-73ea-744e-8fb4-d2aab26f4575",
        "storage_key": "property/6767906449166883/019d08ab-73ea-744e-8fb4-d2aab26f4575.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2SYFt4bnmoARg5ebIbSL-Oo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_28210ef4-5a2d-487c-b901-45334320d729",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "Kaiser Permanente Sacramento Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2025 Morse Ave, Sacramento, CA 95825, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ac-0005-77bc-abda-9bccd1bdf76d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-0005-77bc-abda-9bccd1bdf76d",
        "storage_key": "property/6767906449166883/019d08ac-0005-77bc-abda-9bccd1bdf76d.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://healthy.kaiserpermanente.org/northern-california/facilities/Sacramento-Medical-Center-100330",
      "poi_directions_map_url": "https://maps.google.com/?cid=825758789253687625&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kaiser-permanente-sacramento-medical-center",
      "poi_latitude": "38.6021267",
      "poi_longitude": "-121.3924928",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 916-973-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-7ee0-7218-94d8-7c7762599cdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-7ee0-7218-94d8-7c7762599cdb",
        "storage_key": "property/6767906449166883/019d08ab-7ee0-7218-94d8-7c7762599cdb.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ24Jpp87bmoARSWmfZz6vdQs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_306e9eb5-aa1b-4c76-9056-de271b8ab7e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "Mercy San Juan Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "6501 Coyle Ave, Carmichael, CA 95608, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-21ec-70ce-b0f1-9cde8770f111.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-21ec-70ce-b0f1-9cde8770f111",
        "storage_key": "property/6767906449166883/019d08ab-21ec-70ce-b0f1-9cde8770f111.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.dignityhealth.org/mercy-san-juan-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=323581014851310780&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mercy-san-juan-medical-center",
      "poi_latitude": "38.6696173",
      "poi_longitude": "-121.3140834",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 916-537-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-7ee0-7218-94d8-7c7762599cdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-7ee0-7218-94d8-7c7762599cdb",
        "storage_key": "property/6767906449166883/019d08ab-7ee0-7218-94d8-7c7762599cdb.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJqbHHnfnemoARvNRF9jeXfQQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_db0caa63-39ac-425f-a0de-ee992edee571",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "River Bend Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2300 Rod Beaudry Dr, Sacramento, CA 95827, USA",
      "poi_short_description": "444-acre riverfront park features rafting, equestrian & hiking trails, picnicking space & wildlife.",
      "poi_long_description": "People say this park offers bike trails, hiking trails, picnic areas, and access to the American River. They highlight the abundant wildlife, including deer, turkeys, and various bird species, and the shady, scenic views. They also like the clean restrooms, ample parking, and the availability of BBQ pits and a designated swimming area for children. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-4287-718d-b697-ea44417779a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-4287-718d-b697-ea44417779a1",
        "storage_key": "property/6767906449166883/019d08ab-4287-718d-b697-ea44417779a1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.regionalparks.saccounty.net/Parks/Pages/RiverBendPark.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13299131916403720630&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "river-bend-park",
      "poi_latitude": "38.5952521",
      "poi_longitude": "-121.3302371",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-875-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-7d6b-7681-bf5f-edec80055a77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-7d6b-7681-bf5f-edec80055a77",
        "storage_key": "property/6767906449166883/019d08ab-7d6b-7681-bf5f-edec80055a77.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqqjbDmoARtsFNIgQCkLg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5cf4e5f8-98e2-4c74-82e6-90c24412a31a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "Hagan Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2197 Chase Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Large green space with lots of amenities, including athletic fields, an aquatic center & a dog park.",
      "poi_long_description": "Large green space with lots of amenities, including athletic fields, an aquatic center & a dog park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-38fc-75fa-82fd-82fa2d6ff38a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-38fc-75fa-82fd-82fa2d6ff38a",
        "storage_key": "property/6767906449166883/019d08ab-38fc-75fa-82fd-82fa2d6ff38a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://crpd.com/parks/hagan-community-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13509648951063243279&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hagan-community-park",
      "poi_latitude": "38.6047426",
      "poi_longitude": "-121.3103096",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-369-9844",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-7d6b-7681-bf5f-edec80055a77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-7d6b-7681-bf5f-edec80055a77",
        "storage_key": "property/6767906449166883/019d08ab-7d6b-7681-bf5f-edec80055a77.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ97R8XFXcmoARD2pa0CTqe7s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_cfa0fb41-3753-4a6a-b776-a71031eb118f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "Ancil Hoffman Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6700 Tarshes Dr, Carmichael, CA 95608, USA",
      "poi_short_description": "Noted golf course, nature center & trails featured at a riverfront preserve with ancient oak trees.",
      "poi_long_description": "People say this park offers trails, river access, and opportunities for picnics, fishing, and golf. They highlight the peaceful and beautiful atmosphere, and the chance to see wildlife. They also like the easy parking and well-maintained facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ac-02c8-7769-ac39-163494edcfe0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-02c8-7769-ac39-163494edcfe0",
        "storage_key": "property/6767906449166883/019d08ac-02c8-7769-ac39-163494edcfe0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://regionalparks.saccounty.net/Parks/Pages/AncilHoffmanPark.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=14936912369318475925&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ancil-hoffman-park",
      "poi_latitude": "38.611886",
      "poi_longitude": "-121.310789",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 916-875-6961",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-7d6b-7681-bf5f-edec80055a77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-7d6b-7681-bf5f-edec80055a77",
        "storage_key": "property/6767906449166883/019d08ab-7d6b-7681-bf5f-edec80055a77.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJx8Ubrk3cmoARlbhdJqmSSs8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7d2afb4e-74a0-41b1-b134-2240ffacfffc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "Effie Yeaw Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2850 San Lorenzo Way, Carmichael, CA 95608, USA",
      "poi_short_description": "This attraction offers educational exhibits & over a dozen indigenous animals, plus 3 nature trails.",
      "poi_long_description": "People say this nature preserve offers easy hiking trails, beautiful river views, and opportunities to see wildlife, including deer and birds. They highlight the educational displays, the replica of a Nisenan village, and the well-maintained trails. They also like the friendly volunteers and the peaceful, serene atmosphere. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-4357-7569-adc6-8d7a67ed1cd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-4357-7569-adc6-8d7a67ed1cd2",
        "storage_key": "property/6767906449166883/019d08ab-4357-7569-adc6-8d7a67ed1cd2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.effieyeawnature.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=789343853855929792&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "effie-yeaw-nature-center",
      "poi_latitude": "38.6174656",
      "poi_longitude": "-121.3115716",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 916-876-4918",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-7d6b-7681-bf5f-edec80055a77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-7d6b-7681-bf5f-edec80055a77",
        "storage_key": "property/6767906449166883/019d08ab-7d6b-7681-bf5f-edec80055a77.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJPRlpqUvcmoARwHW4jg1Q9Ao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d8b8e840-9a57-4508-8ee1-10cce193f4b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "Ancil Hoffman Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6700 Tarshes Dr, Carmichael, CA 95608, USA",
      "poi_short_description": "Legendary 1965 course with 5 tee boxes, a chipping/putting area, and a driving range.",
      "poi_long_description": "People say this public golf course offers a fun layout with gorgeous views of the river and challenging holes. They highlight the well-maintained greens and the diverse, mature trees that add to the course's character. They also like the convenient parking and relaxing atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ac-0335-713e-bf8f-12f9d2926cb9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-0335-713e-bf8f-12f9d2926cb9",
        "storage_key": "property/6767906449166883/019d08ac-0335-713e-bf8f-12f9d2926cb9.webp",
        "width": 1280,
        "height": 298
      },
      "poi_business_url": "http://www.golfancilhoffman.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5175700320626769169&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ancil-hoffman-golf-course",
      "poi_latitude": "38.610771",
      "poi_longitude": "-121.3101304",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 916-482-3813",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ac-1f82-770e-9685-6fc652c143d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-1f82-770e-9685-6fc652c143d0",
        "storage_key": "property/6767906449166883/019d08ac-1f82-770e-9685-6fc652c143d0.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJXw0Ps1LcmoAREX3VAgXI00c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_efab10bb-a7d0-4d3f-a619-4ea3cdb8cfbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "Sacramento Mather Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "10425 Norden Ave, Mather, CA 95655, USA",
      "poi_short_description": "",
      "poi_long_description": "Visitors say this airport hosts an awesome air show. They also highlight the amazing performances and photo opportunities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ac-050b-7718-9885-0ae4bc98f954.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-050b-7718-9885-0ae4bc98f954",
        "storage_key": "property/6767906449166883/019d08ac-050b-7718-9885-0ae4bc98f954.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sacramento.aero/mhr",
      "poi_directions_map_url": "https://maps.google.com/?cid=12077780130290008957&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-mather-airport",
      "poi_latitude": "38.5636592",
      "poi_longitude": "-121.297211",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 916-875-7077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-84a1-7163-af60-1d34a16ca61d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-84a1-7163-af60-1d34a16ca61d",
        "storage_key": "property/6767906449166883/019d08ab-84a1-7163-af60-1d34a16ca61d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ290Y9JTCmoARfQM1pQnlnKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_9109ed34-8b7c-4738-94f2-f725ed48c108",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "California Capital Airshow",
      "poi_type": "Transportation & Transit",
      "poi_address": "10425 Norden Ave, Mather, CA 95655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ac-086a-7085-99e5-a05738a385e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-086a-7085-99e5-a05738a385e8",
        "storage_key": "property/6767906449166883/019d08ac-086a-7085-99e5-a05738a385e8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://californiacapitalairshow.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3182739494611207897&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "california-capital-airshow",
      "poi_latitude": "38.5658911",
      "poi_longitude": "-121.3012134",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 916-876-7568",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-84a1-7163-af60-1d34a16ca61d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-84a1-7163-af60-1d34a16ca61d",
        "storage_key": "property/6767906449166883/019d08ab-84a1-7163-af60-1d34a16ca61d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQDQN9PCmoAR2UboHLVcKyw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_690e6fad-6592-4a25-b8bc-17bb1c59bf5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "Mather Field/Mills Station (WB)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Rancho Cordova, CA 95670, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-4c3d-7440-b92f-bf9d44935b19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-4c3d-7440-b92f-bf9d44935b19",
        "storage_key": "property/6767906449166883/019d08ab-4c3d-7440-b92f-bf9d44935b19.webp",
        "width": 1280,
        "height": 1114
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13234103057144582232&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mather-fieldmills-station-wb",
      "poi_latitude": "38.584483",
      "poi_longitude": "-121.311617",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-6c0c-71df-b110-0cf125a103d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-6c0c-71df-b110-0cf125a103d1",
        "storage_key": "property/6767906449166883/019d08ab-6c0c-71df-b110-0cf125a103d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP4eB_uDcmoARWJAD-pz6qLc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_e88b50ce-dff2-4a30-b551-0fb9a2dcce05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "Watt/Manlove Station (WB)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Rosemont, CA 95826, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6840555224202113319&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wattmanlove-station-wb",
      "poi_latitude": "38.553684",
      "poi_longitude": "-121.373651",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-6c0c-71df-b110-0cf125a103d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-6c0c-71df-b110-0cf125a103d1",
        "storage_key": "property/6767906449166883/019d08ab-6c0c-71df-b110-0cf125a103d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXdILj0jbmoARJ3ECzbuI7l4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_7048df77-4379-4a8c-8155-f940360bec33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "Sunrise Station (WB)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Rancho Cordova, CA 95742, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6001742365687852160&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sunrise-station-wb",
      "poi_latitude": "38.606523",
      "poi_longitude": "-121.267248",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-6c0c-71df-b110-0cf125a103d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-6c0c-71df-b110-0cf125a103d1",
        "storage_key": "property/6767906449166883/019d08ab-6c0c-71df-b110-0cf125a103d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxb7Rk3zdmoARgKw8DOJ4SlM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_a5f43e3e-f535-4e5f-9bae-1f7410353f03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "Solidigm",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10951 White Rock Rd, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.solidigm.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=206253238189211691&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "solidigm",
      "poi_latitude": "38.5904826",
      "poi_longitude": "-121.2786463",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 855-765-4301",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-6c0c-71df-b110-0cf125a103d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-6c0c-71df-b110-0cf125a103d1",
        "storage_key": "property/6767906449166883/019d08ab-6c0c-71df-b110-0cf125a103d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf3C6eTLdmoARK8AKNDrC3AI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e7030472-1293-4394-b128-febe7fb62334",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "Rancho Cordova City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2729 Prospect Park Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-6198-77c8-a27c-a202ede9d4a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-6198-77c8-a27c-a202ede9d4a1",
        "storage_key": "property/6767906449166883/019d08ab-6198-77c8-a27c-a202ede9d4a1.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.cityofranchocordova.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9712799136449957214&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rancho-cordova-city-hall",
      "poi_latitude": "38.5892875",
      "poi_longitude": "-121.284565",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 916-851-8700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-84a9-70c5-9ecf-96db661d01fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-84a9-70c5-9ecf-96db661d01fb",
        "storage_key": "property/6767906449166883/019d08ab-84a9-70c5-9ecf-96db661d01fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMfmFE0DdmoARXg3SnlrLyoY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_1d37a8a7-9c37-4c1c-b289-4d22a563f4ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "Youth Detention Facility",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9601 Kiefer Blvd, Sacramento, CA 95827, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ac-0f4a-75fa-8f73-ea921d5bcba3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-0f4a-75fa-8f73-ea921d5bcba3",
        "storage_key": "property/6767906449166883/019d08ac-0f4a-75fa-8f73-ea921d5bcba3.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.saccounty.net/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3424225278182912545&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "youth-detention-facility",
      "poi_latitude": "38.5464838",
      "poi_longitude": "-121.3411412",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-876-9301",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-84a9-70c5-9ecf-96db661d01fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-84a9-70c5-9ecf-96db661d01fb",
        "storage_key": "property/6767906449166883/019d08ab-84a9-70c5-9ecf-96db661d01fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEYKdmUXDmoARIXIBib9KhS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_434e6d2f-1f15-47a2-9afc-d7d1f8334bda",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "VSP",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3333 Quality Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-55a3-75fc-a02e-a83083fcc266.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-55a3-75fc-a02e-a83083fcc266",
        "storage_key": "property/6767906449166883/019d08ab-55a3-75fc-a02e-a83083fcc266.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.vsp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10214769660848340697&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vsp",
      "poi_latitude": "38.5837561",
      "poi_longitude": "-121.2884037",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 916-851-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-6c0c-71df-b110-0cf125a103d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-6c0c-71df-b110-0cf125a103d1",
        "storage_key": "property/6767906449166883/019d08ab-6c0c-71df-b110-0cf125a103d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnwgV7z7dmoAR2X5N6eImwo0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_86ebc99f-5b1b-49ad-b16b-160f30d1d07a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "poi_name": "Sacramento Metropolitan Fire District Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10545 Armstrong Ave STE 200, Mather, CA 95655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ac-0e75-72ab-ae38-de3dfe7ba090.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-0e75-72ab-ae38-de3dfe7ba090",
        "storage_key": "property/6767906449166883/019d08ac-0e75-72ab-ae38-de3dfe7ba090.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://metrofire.ca.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9756846587005145379&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-metropolitan-fire-district-headquarters",
      "poi_latitude": "38.569597",
      "poi_longitude": "-121.2963098",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 916-859-4300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08ab-6c0c-71df-b110-0cf125a103d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-6c0c-71df-b110-0cf125a103d1",
        "storage_key": "property/6767906449166883/019d08ab-6c0c-71df-b110-0cf125a103d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT7dVkDLdmoARI5Fs4kZIZ4c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_806f6d70-2da1-4cb3-952f-c5a13ece4444",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "day": "SUN",
      "open_time": "10:00",
      "close_time": "16:00"
    },
    {
      "id": "custom_35033624-023e-4064-9d38-5fecbe7c80ba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_fa6428f9-d824-46de-b29e-4b262e34e218",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_f91d6112-7e3f-4810-aa96-e920a2710e69",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_2b7698e2-4e35-4279-af8a-14991eceb9dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_8bb550d8-9d10-46dc-8731-0ef411dde9c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_7ed232dc-726d-4211-95aa-48169a8b96e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_0858e090-0d4d-4a12-965d-33e66e74a32c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "rating": "5.0",
      "name": "cj Kennedy",
      "text": "The Bishop's Court Apartments Manager; Sabrina, is one of the best property managers I've ever had. She is always friendly, always responsive to any concern or issue, and she takes great pride in caring for the property, very nice & helpful. The property itself and my apartment are well maintained. The grounds, pool, Gym, & other common areas are well maintained, and although I've only had a few maintenance issue since I've lived here they are handled promptly & correctly with no mess left behind. Other tenants all agree we are very lucky to have such attentive management here! All of my neighbors are genuinely nice people. No rowdy or loud people, just decent, good people all around. I feel that I am fortunate & extremely grateful to be living here!..",
      "date": "2019-11-25",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_ce4a6a60-f03d-4421-89d0-b447ce7d4501",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d2b17-1046-722f-b86d-0f5a5a0b8cc7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2b17-1046-722f-b86d-0f5a5a0b8cc7",
        "storage_key": "property/6767906449166883/019d2b17-1046-722f-b86d-0f5a5a0b8cc7.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Bishop’s Court Apartments - Pool & Spa",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=GsHY4TTRYm1"
    },
    {
      "id": "custom_8cf5f726-47f2-4928-bdf1-599e487143ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d2b17-7bfa-76a1-912f-bf30a1d2e2ac.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2b17-7bfa-76a1-912f-bf30a1d2e2ac",
        "storage_key": "property/6767906449166883/019d2b17-7bfa-76a1-912f-bf30a1d2e2ac.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Bishop’s Court Apartments - Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=LpGr35VgBVC&brand=0"
    },
    {
      "id": "custom_09f314d9-e0f1-4e48-9189-5cb5dc4455a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d2b16-a568-71f9-9405-c42c22d6ffca.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2b16-a568-71f9-9405-c42c22d6ffca",
        "storage_key": "property/6767906449166883/019d2b16-a568-71f9-9405-c42c22d6ffca.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Bishop’s Court Apartments - 1 Bedroom 1 Bath 625 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=oCNW6YKk8iL"
    },
    {
      "id": "custom_9a4df469-1b7b-4382-a3f0-ca6ff464b5ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d2b16-cba4-72c8-9e92-126185c0cced.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2b16-cba4-72c8-9e92-126185c0cced",
        "storage_key": "property/6767906449166883/019d2b16-cba4-72c8-9e92-126185c0cced.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Bishop’s Court Apartments - 2 Bedroom 1 Bath 852 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=zb4XvpHCYRS"
    },
    {
      "id": "custom_c9801114-325c-41cd-ac3c-d2b09a068119",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d2b16-f1dd-718c-b6c7-bfd466b7e96d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2b16-f1dd-718c-b6c7-bfd466b7e96d",
        "storage_key": "property/6767906449166883/019d2b16-f1dd-718c-b6c7-bfd466b7e96d.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Bishop’s Court Apartments - 2 Bedroom 2 Bath 880 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=nCEu6m3AFKv"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db126-00c8-7060-8fad-6bb3d1f2a60b",
      "lead_source": "LANDING_PAGE",
      "name": "Bishop's Court Apartments Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-rancho-cordova",
      "search_query": "apartments with in-unit laundry in Rancho Cordova",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry at Bishop's Court",
      "h2_subtitle": "Discover apartments with in-unit laundry at Bishop's Court. Our Rancho Cordova community offers modern living with exceptional amenities.",
      "page_copy": "Explore the comfort of living at Bishop's Court in Rancho Cordova, where our apartments feature convenient in-unit laundry. Experience the freedom of washing clothes at home, and enjoy spacious living spaces that cater to your lifestyle. Our community, nestled in the heart of Sacramento County, offers more than just laundry luxury. Immerse yourself in amenities including two pristine swimming pools, a 24-hour fitness center, and a resident activity program designed to enrich your social life.\n\nChoose from our selection of one, two, and three-bedroom apartments tailored for modern convenience. Beyond in-unit laundry, you'll appreciate smoke-free living, a game library, and an all-access playground for leisure time. Located in the charming neighborhood of Outer Rancho Cordova, Bishop’s Court promises the perfect blend of comfort and accessibility. Schedule a tour today and see for yourself why Bishop's Court is the ideal community for your next home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and trees in the background.",
        "public_id": "019d08aa-302f-7059-9636-5da3e3b4bdc0",
        "storage_key": "property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry at Bishop's Court",
      "seo_description": "Find apartments with in-unit laundry at Bishop's Court, Rancho Cordova. Discover a comfortable lifestyle with excellent amenities offered.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-sacramento-county",
      "search_query": "air conditioned apartments Sacramento County",
      "category": "Amenity",
      "h1_title": "Air Conditioned Comfort at Bishop's Court",
      "h2_subtitle": "Explore air conditioned apartments in Sacramento County. Bishop's Court offers cool and comfortable living with top-notch amenities.",
      "page_copy": "Welcome to Bishop's Court, where air conditioned apartments in Sacramento County offer refreshing comfort year-round. Our community in Rancho Cordova provides you with a cool oasis, perfect for escaping the summer heat. Each apartment is thoughtfully designed to ensure you experience ultimate relaxation and comfort, with air conditioning as a standard feature.\n\nBishop's Court not only promises climate-controlled living but also enriches your lifestyle with exceptional amenities. Dive into our sparkling swimming pools, challenge yourself at the 24-hour fitness center, or unwind at the game library. With a location in the Outer Rancho Cordova neighborhood, you'll be minutes away from local dining and shopping options, all while enjoying the smoke-free environment and enthusiastic community activities. Discover air conditioned living at its best — schedule a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and trees in the background.",
        "public_id": "019d08aa-302f-7059-9636-5da3e3b4bdc0",
        "storage_key": "property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments at Bishop's Court",
      "seo_description": "Live comfortably in air conditioned apartments in Sacramento County at Bishop's Court, Rancho Cordova. Enjoy modern amenities and a cool lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "generator",
      "page_item_url": "dedicated-parking-apartments-outer-rancho-cordova",
      "search_query": "apartments with dedicated parking near Outer Rancho Cordova",
      "category": "Amenity",
      "h1_title": "Dedicated Parking at Bishop's Court",
      "h2_subtitle": "Find apartments with dedicated parking near Outer Rancho Cordova. Enjoy hassle-free parking and top-notch amenities at Bishop's Court.",
      "page_copy": "Discover the convenience of having dedicated parking at Bishop's Court in the Outer Rancho Cordova area. No more worrying about finding a spot when you arrive home. Our community makes parking easy and stress-free, adding convenience to your daily life. Apart from the secure parking, residents benefit from a vibrant and well-equipped living environment.\n\nBishop's Court offers spacious one, two, and three-bedroom apartments with a variety of amenities that cater to modern needs. From our refreshing swimming pools and a 24-hour fitness center to the playground and game library, every feature is designed to enhance your residential experience. Positioned in scenic Sacramento County, our smoke-free housing community is perfect for those seeking a practical yet comfortable lifestyle. Visit us today and experience dedicated parking and much more.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and trees in the background.",
        "public_id": "019d08aa-302f-7059-9636-5da3e3b4bdc0",
        "storage_key": "property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bishop's Court: Parking & Amenities",
      "seo_description": "Enjoy dedicated parking at Bishop's Court near Outer Rancho Cordova. Live conveniently with excellent amenities and spacious apartments.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "generator",
      "page_item_url": "apartment-pools-rancho-cordova-ca",
      "search_query": "apartment pools Rancho Cordova CA",
      "category": "Amenity",
      "h1_title": "Swim at Bishop's Court Pools",
      "h2_subtitle": "Discover apartment pools in Rancho Cordova, CA. Bishop's Court offers two sparkling pools for your relaxation and enjoyment.",
      "page_copy": "Dive into luxury at Bishop's Court, where our apartment pools in Rancho Cordova, CA offer the perfect escape from the daily grind. Our community features not one, but two pristine swimming pools, providing ample opportunities for relaxation and recreation right at your doorstep. Whether you prefer a morning swim or an afternoon lounging by the water, our pools are a great place to unwind.\n\nLocated in Sacramento County, Bishop's Court provides more than impeccable pools. Our residents enjoy a comprehensive suite of amenities, including a 24-hour fitness center, a playground, and a game library. Our smoke-free community also supports active social engagement with a vibrant resident activity program. Choose from our variety of spacious apartment layouts and envelop yourself in convenience and leisure. Visit Bishop's Court today and see why our pools are a hot spot in Rancho Cordova!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and trees in the background.",
        "public_id": "019d08aa-302f-7059-9636-5da3e3b4bdc0",
        "storage_key": "property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bishop's Court Pools: Relax and Enjoy",
      "seo_description": "Enjoy two sparkling apartment pools at Bishop's Court in Rancho Cordova, CA. Experience luxury living with top-notch amenities and spacious apartments.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "generator",
      "page_item_url": "24-hour-fitness-center-apartments-rancho-cordova",
      "search_query": "24-hour fitness center apartments Rancho Cordova",
      "category": "Amenity",
      "h1_title": "Fitness Anytime at Bishop's Court",
      "h2_subtitle": "Live in 24-hour fitness center apartments in Rancho Cordova. Bishop's Court provides constant access to wellness facilities and more.",
      "page_copy": "Welcome to the fitness-focused living experience at Bishop's Court, where 24-hour fitness center apartments in Rancho Cordova redefine convenience and health. Our fully equipped gym is open around the clock, ensuring that no matter how busy your schedule, you always have time to prioritize your well-being. Embrace a healthier lifestyle and meet your fitness goals without leaving home.\n\nBeyond the fitness center, Bishop's Court offers a wonderful array of amenities in the heart of Rancho Cordova, Sacramento County. Enjoy leisure activities with our two sparkling swimming pools, playground, and game library. Living here comes with the added benefit of online rent payments and a smoke-free environment, enhancing your residential comfort. Discover the joy of having a fitness center just steps away from your door. Visit Bishop's Court and explore our spacious apartment options today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and trees in the background.",
        "public_id": "019d08aa-302f-7059-9636-5da3e3b4bdc0",
        "storage_key": "property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "24-Hour Fitness at Bishop's Court",
      "seo_description": "Enjoy 24-hour fitness center apartments at Bishop's Court in Rancho Cordova. Access wellness facilities and premium amenities anytime.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-rancho-cordova-ca",
      "search_query": "1 bedroom apartments rancho cordova ca",
      "category": "Floorplan",
      "h1_title": "Spacious 1-Bedroom Apartments in Rancho Cordova",
      "h2_subtitle": "Explore 1 bedroom apartments in Rancho Cordova, CA at Bishop's Court. Perfectly blend comfort with modern living in our spacious units.",
      "page_copy": "Discover modern living at its finest with our 1-bedroom apartments in Rancho Cordova, CA at Bishop's Court. Our thoughtfully designed units provide ample space and contemporary amenities for a comfortable lifestyle. Whether you're a young professional seeking a convenient location or someone looking to downsize, our one-bedroom layouts offer the ideal solution.\n\nLocated in the delightful community of Outer Rancho Cordova, Bishop's Court isn't just about an apartment. Enjoy the benefits of living in a smoke-free community with access to fantastic amenities like a 24-hour fitness center and two sparkling pools. With our online rent payments, resident activities, and more, experience ease and enjoyment every day. Visit us and discover your new home at Bishop's Court!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and trees in the background.",
        "public_id": "019d08aa-302f-7059-9636-5da3e3b4bdc0",
        "storage_key": "property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bishop's Court 1-Bedroom Apartments",
      "seo_description": "Find your perfect 1-bedroom apartment at Bishop's Court in Rancho Cordova, CA. Enjoy modern amenities and spacious living in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-sacramento-county",
      "search_query": "2 bedroom apartments sacramento county",
      "category": "Floorplan",
      "h1_title": "Comfortable 2-Bedroom Apartments in Sacramento County",
      "h2_subtitle": "Discover 2-bedroom apartments in Sacramento County at Bishop's Court. Enjoy spacious layouts and luxury amenities in Rancho Cordova, CA.",
      "page_copy": "For those seeking the perfect blend of space and comfort, our 2-bedroom apartments in Sacramento County offer a remarkable living experience. Nestled in the vibrant community of Rancho Cordova, Bishop's Court presents meticulously designed two-bedroom layouts with all the modern conveniences you expect. Ideal for families, roommates, or anyone craving a little extra room.\n\nBishop's Court is more than a place to live; it's a lifestyle. Enjoy amenities such as two refreshing swimming pools and a state-of-the-art 24-hour fitness center. Our smoke-free community also offers a game library and playground, making it suitable for a diverse group of residents. Explore the vibrant activities program, and settle into a community that puts comfort and convenience at the forefront. Schedule a tour today to see how Bishop's Court can be your next home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and trees in the background.",
        "public_id": "019d08aa-302f-7059-9636-5da3e3b4bdc0",
        "storage_key": "property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2-Bedroom Apartments in Sacramento County",
      "seo_description": "Find spacious 2-bedroom apartments at Bishop's Court in Sacramento County. Enjoy luxury living with top-tier amenities in Rancho Cordova.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-near-outer-rancho-cordova",
      "search_query": "3 bedroom apartments near outer rancho cordova",
      "category": "Floorplan",
      "h1_title": "Spacious 3-Bedroom Living Near Rancho Cordova",
      "h2_subtitle": "Explore spacious 3 bedroom apartments near Outer Rancho Cordova. Experience luxury and ample space at Bishop's Court.",
      "page_copy": "Looking for expansive living spaces in a prime location? Check out the 3 bedroom apartments near Outer Rancho Cordova at Bishop’s Court. Our generous floor plans are designed to accommodate families or those who simply want additional space for a home office or guest room. Each apartment is crafted with attention to detail, ensuring you enjoy both style and functionality.\n\nLocated in the desirable neighborhood of Rancho Cordova, our community offers a plethora of amenities that enhance your living experience. Dive into relaxation at our two swimming pools, engage in fitness activities in the 24-hour gym, or enjoy family time at the playground. As a smoke-free community, Bishop’s Court also provides the convenience of online rent payments. Visit us to experience spacious living in a vibrant location today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and trees in the background.",
        "public_id": "019d08aa-302f-7059-9636-5da3e3b4bdc0",
        "storage_key": "property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3-Bedroom Apartments Near Rancho Cordova",
      "seo_description": "Discover spacious 3-bedroom apartments near Outer Rancho Cordova at Bishop's Court. Enjoy modern amenities and large living spaces today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "generator",
      "page_item_url": "apartments-near-american-river-college-sacramento-county",
      "search_query": "apartments near american river college sacramento county",
      "category": "School",
      "h1_title": "Convenient Apartments Near American River College",
      "h2_subtitle": "Discover stylish apartments near American River College in Sacramento County. Enjoy modern amenities and a welcoming community at Bishop's Court.",
      "page_copy": "If you're searching for apartments near American River College in Sacramento County, consider Bishop’s Court. Located within an easy commute, our community offers a blend of comfort and convenience tailored for students and professionals alike. Enjoy thoughtfully designed one, two, or three-bedroom layouts that cater to various lifestyle needs.\n\nOur Rancho Cordova location provides a peaceful escape with access to amenities that enrich daily life. Dive into our swimming pools for relaxation, stay active with our 24-hour fitness center, or find some down-time in our game library. The smoke-free environment promotes a healthy living standard, complemented by seamless online rent payments. Visit Bishop's Court and see how close proximity to learning and luxury can elevate your lifestyle today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and trees in the background.",
        "public_id": "019d08aa-302f-7059-9636-5da3e3b4bdc0",
        "storage_key": "property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near American River College",
      "seo_description": "Find convenient apartments near American River College at Bishop's Court in Sacramento County. Enjoy upscale living and easy commutes.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "generator",
      "page_item_url": "apartments-near-kaiser-permanente-sacramento-medical-center",
      "search_query": "apartments near Kaiser Permanente Sacramento Medical Center CA",
      "category": "Hospital",
      "h1_title": "Convenient Living Near Kaiser Permanente Sacramento",
      "h2_subtitle": "Find comfortable apartments near Kaiser Permanente Sacramento Medical Center, CA. Enjoy modern living at Bishop's Court, a short commute away.",
      "page_copy": "Searching for convenient apartments near Kaiser Permanente Sacramento Medical Center, CA? Bishop’s Court offers the ideal residence. Located in Rancho Cordova, our community provides an excellent living experience just a short drive from the medical center, making it perfect for healthcare professionals and patients seeking nearby accommodations.\n\nChoose from our spacious one, two, or three-bedroom apartments designed with modern needs in mind. Enjoy amenities such as two sparkling swimming pools, a 24-hour fitness center, and a vibrant resident activity program. Our smoke-free community emphasizes a healthy lifestyle while offering conveniences like online rent payments. Discover how Bishop’s Court offers proximity and comfort, ensuring you're never far from what matters. Schedule a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and trees in the background.",
        "public_id": "019d08aa-302f-7059-9636-5da3e3b4bdc0",
        "storage_key": "property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kaiser Permanente Sacramento",
      "seo_description": "Discover comfortable living near Kaiser Permanente Sacramento Medical Center at Bishop's Court. Ideal for easy commutes and quality living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "generator",
      "page_item_url": "apartments-close-to-mercy-san-juan-medical-center",
      "search_query": "apartments close to Mercy San Juan Medical Center Outer Rancho Cordova",
      "category": "Hospital",
      "h1_title": "Prime Living Close to Mercy San Juan Medical Center",
      "h2_subtitle": "Explore modern apartments close to Mercy San Juan Medical Center in Outer Rancho Cordova. Bishop's Court offers the perfect blend of comfort and convenience.",
      "page_copy": "Are you looking for apartments close to Mercy San Juan Medical Center in Outer Rancho Cordova? Bishop's Court is the ideal choice. Our community provides spacious living options suitable for professionals and families alike, ensuring a comfortable stay just a short drive from the medical center.\n\nFeaturing an array of amenities, Bishop’s Court enhances your living experience with two refreshing swimming pools, a well-equipped 24-hour fitness center, and a community playground. Embrace smoke-free living and enjoy the ease of online rent payments. Our one, two, or three-bedroom apartments are crafted to cater to your modern lifestyle needs. Experience convenience and luxury with a visit to Bishop's Court today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and trees in the background.",
        "public_id": "019d08aa-302f-7059-9636-5da3e3b4bdc0",
        "storage_key": "property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Mercy San Juan Medical Center",
      "seo_description": "Find modern apartments close to Mercy San Juan Medical Center in Outer Rancho Cordova at Bishop's Court. Enjoy proximity and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "generator",
      "page_item_url": "apartments-near-river-bend-park-rancho-cordova",
      "search_query": "apartments near River Bend Park Rancho Cordova",
      "category": "Park",
      "h1_title": "Living Near River Bend Park in Rancho Cordova",
      "h2_subtitle": "Discover beautiful apartments near River Bend Park in Rancho Cordova. Bishop's Court offers a perfect blend of nature and modern living.",
      "page_copy": "Looking for apartments near River Bend Park in Rancho Cordova? Bishop’s Court provides a serene living environment just a stone’s throw from one of the area’s most beloved parks. Our community offers you the tranquility of nature coupled with the conveniences of modern living.\n\nChoose from our spacious layouts of one, two, or three-bedroom apartments, each designed with comfortable, contemporary style. Enjoy amenities like two sparkling swimming pools and a 24-hour fitness center, ideal for unwinding after a day at the park. Our smoke-free environment and seamless online rent payments make daily life stress-free. Embrace the perfect lifestyle balance at Bishop’s Court, close to scenic beauty and urban amenities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and trees in the background.",
        "public_id": "019d08aa-302f-7059-9636-5da3e3b4bdc0",
        "storage_key": "property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near River Bend Park Rancho Cordova",
      "seo_description": "Find your home at Bishop's Court, near River Bend Park in Rancho Cordova. Enjoy nature, modern amenities, and easy access to outdoor fun.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "generator",
      "page_item_url": "apartments-close-to-hagan-community-park-95670",
      "search_query": "apartments close to Hagan Community Park 95670",
      "category": "Park",
      "h1_title": "Easy Living Near Hagan Community Park",
      "h2_subtitle": "Explore apartments close to Hagan Community Park, 95670. Bishop's Court offers the perfect home base for recreation and relaxation in Rancho Cordova.",
      "page_copy": "Searching for delightful apartments close to Hagan Community Park in the 95670 area? Bishop’s Court provides a vibrant living experience just minutes from the sprawling greenery and amenities of this local favorite park. Perfect for those who love outdoor activities, our community offers convenient access to recreational spaces.\n\nEnjoy spacious one, two, or three-bedroom apartments designed for modern comfort. Residents benefit from two inviting swimming pools, a 24-hour fitness center, and a smoke-free environment. Complement your active lifestyle with our engaging resident activity programs and playground facilities. With options like online rent payments, living here is not just about a home, it's about a lifestyle. Discover Bishop’s Court – where proximity meets luxury.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and trees in the background.",
        "public_id": "019d08aa-302f-7059-9636-5da3e3b4bdc0",
        "storage_key": "property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Hagan Community Park",
      "seo_description": "Bishop's Court offers ideal apartments close to Hagan Community Park 95670. Enjoy urban amenities and park-side living in Rancho Cordova.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "generator",
      "page_item_url": "ancil-hoffman-park-nearby-apartments-sacramento-county",
      "search_query": "Ancil Hoffman Park nearby apartments Sacramento County",
      "category": "Park",
      "h1_title": "Home Near Ancil Hoffman Park in Sacramento",
      "h2_subtitle": "Discover Ancil Hoffman Park nearby apartments in Sacramento County. Bishop’s Court offers a perfect balance of natural beauty and modern convenience.",
      "page_copy": "Are you on the hunt for Ancil Hoffman Park nearby apartments in Sacramento County? Bishop's Court is the perfect spot, offering an ideal blend of proximity to nature and exceptional living amenities. Located conveniently within Sacramento County, our community places you close to this beautiful park known for its lush landscapes and golf opportunities.\n\nExperience the dynamic lifestyle at Bishop’s Court, where you have a selection of spacious one, two, and three-bedroom layouts. Our residents enjoy unparalleled access to two swimming pools, a fully-equipped 24-hour fitness center, and family-friendly amenities like a playground and game library. Enjoy the ease of online rent payments and smoke-free living. Come and see why Bishop’s Court is the perfect home base for exploring all that Ancil Hoffman Park and Sacramento County have to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and trees in the background.",
        "public_id": "019d08aa-302f-7059-9636-5da3e3b4bdc0",
        "storage_key": "property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Ancil Hoffman Park Nearby Apartments",
      "seo_description": "Find ideal living at Bishop's Court with Ancil Hoffman Park nearby. Enjoy Sacramento County's natural beauty and our modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "generator",
      "page_item_url": "effie-yeaw-nature-center-nearby-apartment-living-outer-rancho-cordova",
      "search_query": "Effie Yeaw Nature Center nearby apartment living Outer Rancho Cordova",
      "category": "Park",
      "h1_title": "Apartment Living Near Effie Yeaw Nature Center",
      "h2_subtitle": "Explore Effie Yeaw Nature Center nearby apartments in Outer Rancho Cordova. Bishop's Court offers a unique living experience close to nature.",
      "page_copy": "For those seeking Effie Yeaw Nature Center nearby apartment living in Outer Rancho Cordova, Bishop’s Court provides an unparalleled living experience immersed in natural beauty. Nestled in a prime location, our community offers the advantage of easy access to the nature center while providing modern comforts and conveniences.\n\nChoose from a variety of spacious one, two, and three-bedroom apartments, each thoughtfully designed. Residents can enjoy a host of amenities such as two sparkling pools, a 24-hour fitness center, and a vibrant resident activity program. With our smoke-free environment and convenient online rent payments, living here is both enjoyable and hassle-free. Discover the best of both worlds at Bishop’s Court, where nature and contemporary living meet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and trees in the background.",
        "public_id": "019d08aa-302f-7059-9636-5da3e3b4bdc0",
        "storage_key": "property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Effie Yeaw Nearby Apartment Living",
      "seo_description": "Discover apartment living at Bishop's Court near Effie Yeaw Nature Center. Enjoy Outer Rancho Cordova's natural and modern lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "generator",
      "page_item_url": "apartments-near-mather-field-mills-station-rancho-cordova",
      "search_query": "apartments near Mather Field Mills Station Rancho Cordova",
      "category": "Transit",
      "h1_title": "Convenient Living Near Mather Field Station",
      "h2_subtitle": "Find apartments near Mather Field Mills Station in Rancho Cordova. Bishop's Court offers the ideal home for commuters and explorers alike.",
      "page_copy": "If you're searching for apartments near Mather Field Mills Station in Rancho Cordova, look no further than Bishop’s Court. Our community's prime location offers easy access to the station, perfect for those who value convenient commutes and spontaneous adventures.\n\nChoose from spacious one, two, or three-bedroom apartment homes tailored to fit modern lifestyles. Residents enjoy amenities such as two shimmering swimming pools, a comprehensive 24-hour fitness center, and engaging community activities. Our smoke-free housing and convenient online rent payment options make living simple and stress-free. Discover the connection between comfort and convenience at Bishop’s Court, where urban living is redefined.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and trees in the background.",
        "public_id": "019d08aa-302f-7059-9636-5da3e3b4bdc0",
        "storage_key": "property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mather Field Mills Station",
      "seo_description": "Bishop's Court offers perfect apartments near Mather Field Mills Station, Rancho Cordova. Enjoy easy commutes and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "generator",
      "page_item_url": "bishops-court-apartments-close-to-watt-manlove-station-ca",
      "search_query": "Bishop's Court apartments close to Watt Manlove Station CA",
      "category": "Transit",
      "h1_title": "Bishop's Court Near Watt Manlove Station",
      "h2_subtitle": "Discover Bishop's Court apartments close to Watt Manlove Station, CA. Convenient, connected living awaits in a vibrant community.",
      "page_copy": "Looking for Bishop's Court apartments close to Watt Manlove Station, CA? Our community is perfectly situated for those who want an easy commute and a dynamic living environment. Bishop's Court offers a blend of contemporary apartment living with the advantage of being near key transit options.\n\nChoose from one, two, or three-bedroom apartment homes that are well-suited for modern lifestyles. Enjoy an exceptional array of amenities like dual swimming pools, a state-of-the-art 24-hour fitness facility, and an active resident community. With our smoke-free environment and the convenience of online rent payments, living at Bishop’s Court is both effortless and enjoyable. Immerse yourself in a lifestyle where urban connectivity and modern comfort meet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and trees in the background.",
        "public_id": "019d08aa-302f-7059-9636-5da3e3b4bdc0",
        "storage_key": "property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bishop's Court Near Watt Manlove Station",
      "seo_description": "Live at Bishop's Court, conveniently close to Watt Manlove Station, CA. Enjoy easy access and a vibrant living atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166883",
      "source": "generator",
      "page_item_url": "sacramento-county-apartments-by-sunrise-station-wb",
      "search_query": "Sacramento County apartments by Sunrise Station WB",
      "category": "Transit",
      "h1_title": "Apartments Near Sunrise Station WB",
      "h2_subtitle": "Explore Sacramento County apartments by Sunrise Station WB. Bishop's Court offers modern convenience with commuter-friendly options.",
      "page_copy": "If you're on the hunt for Sacramento County apartments by Sunrise Station WB, Bishop’s Court should top your list. Our community combines the ease of public transit access with a vibrant living experience, making it ideal for commuters and those seeking an active lifestyle.\n\nWe offer spacious one, two, and three-bedroom units designed for comfort and style. The community boasts superior amenities including two glittering pools, a comprehensive 24-hour fitness center, and a dynamic resident activity program. Our smoke-free environment and online rent payment systems ensure hassle-free living. At Bishop's Court, you'll find urban convenience paired with modern amenities, all close to the Sunrise Station WB.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and trees in the background.",
        "public_id": "019d08aa-302f-7059-9636-5da3e3b4bdc0",
        "storage_key": "property/6767906449166883/019d08aa-302f-7059-9636-5da3e3b4bdc0.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Sunrise Station WB",
      "seo_description": "Find Sacramento County apartments near Sunrise Station WB at Bishop's Court. Enjoy modern conveniences and excellent access to public transit.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5958"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18372413658"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "\tGTM-W9BW27SK"
    },
    {
      "ID": "custom_company_license_number",
      "type": "STRING",
      "value": "#01090130"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-766-3761 "
    }
  ],
  "custom_qb_id": "5958",
  "custom_repli_id": "18372413658",
  "custom_google_gtm_id": "\tGTM-W9BW27SK",
  "custom_company_license_number": "#01090130",
  "custom_ppc_tracking_phone_number": "844-766-3761 "
};

export const generatedAt = '2026-09-23T19:57:11.862Z';
